(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6619],{

/***/ 32990:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add/[[...currency]]",
      function () {
        return __webpack_require__(20458);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardBody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df4f0a61-0"
}).withConfig({
    componentId: "sc-657c9e-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardBody.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardBody);


/***/ }),

/***/ 5349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardFooter = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5ed8a823-0"
}).withConfig({
    componentId: "sc-cddac6ee-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardFooter.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardFooter);


/***/ }),

/***/ 63822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.71005 11.71L11.3001 14.3C11.6901 14.69 12.3201 14.69 12.7101 14.3L15.3001 11.71C15.9301 11.08 15.4801 10 14.5901 10H9.41005C8.52005 10 8.08005 11.08 8.71005 11.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 67290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 40 40"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.2487 9.59637L10.7888 7.58546L20.1999 2.08337L29.6387 7.58546L26.1787 9.59637L20.1999 6.13313L14.2487 9.59637ZM32.1022 13.0596V17.1094L35.5622 15.0985V11.0487L32.1022 9.00986L28.6422 11.0208L32.1022 13.0596ZM16.7399 11.0487L20.1999 13.0596L23.6599 11.0487L20.1999 9.00986L16.7399 11.0487ZM29.6387 14.5119L26.1787 12.501L20.1999 15.9643L14.2487 12.501L10.7888 14.5119V18.5617L16.7399 22.0249V28.9514L20.1999 30.9623L23.6599 28.9514V22.0249L29.6387 18.5617V14.5119ZM32.1022 26.9405L26.1511 30.4038V34.4535L35.5899 28.9514V17.9752L32.1022 20.014V26.9405ZM26.1511 27.527L29.611 25.5161V21.4384L26.1511 23.4493V27.527ZM16.7399 31.8561V35.9058L20.1999 37.9168L23.6599 35.9058V31.8561L20.1999 33.867L16.7399 31.8561ZM4.80992 15.0985L8.2699 17.1094V13.0596L11.7299 11.0487L8.29758 9.00986L4.8376 11.0208V15.0985H4.80992ZM8.29758 20.014L4.8376 18.0031V28.9794L14.2764 34.4814V30.4317L8.29758 26.9405V20.014ZM14.2487 23.4773L10.7888 21.4664V25.5161L14.2487 27.527V23.4773Z",
            fill: "#F1BA0D"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 58600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        x: "0px",
        y: "0px",
        viewBox: "0 0 1000 1000"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: 416.6229,
                y1: 16.304,
                x2: 416.6229,
                y2: 985.446,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: 0.3,
                        stopColor: "#ff1b2d"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: 0.4381,
                        stopColor: "#fa1a2c"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: 0.5939,
                        stopColor: "#ed1528"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: 0.7581,
                        stopColor: "#d60e21"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: 0.9272,
                        stopColor: "#b70519"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: 1,
                        stopColor: "#a70014"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M335.4 781.8c-55.3-65.3-91.1-161.7-93.5-270v-23.6c2.4-108.3 38.2-204.7 93.5-270C407.2 125.1 513.8 66 632.8 66c73.2 0 141.8 22.4 200.4 61.3C745.2 48.5 629.2.5 501.9 0H500C223.9 0 0 223.9 0 500c0 268.2 211.1 487 476.2 499.4 7.9.4 15.8.6 23.8.6 128 0 244.8-48.1 333.2-127.2-58.6 38.8-127.1 61.2-200.4 61.2-119 0-225.6-59.1-297.4-152.2z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                id: "b",
                gradientUnits: "userSpaceOnUse",
                x1: 667.7092,
                y1: 73.4257,
                x2: 667.7092,
                y2: 930.5844,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: 0,
                        stopColor: "#9c0000"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: 0.7,
                        stopColor: "#ff4b4b"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M335.4 218.2c45.9-54.2 105.1-86.8 169.9-86.8 145.6 0 263.5 165 263.5 368.6s-118 368.6-263.5 368.6c-64.7 0-124-32.7-169.9-86.8C407.2 874.9 513.8 934 632.8 934c73.2 0 141.8-22.4 200.4-61.2C935.6 781.2 1000 648.1 1000 500c0-148.1-64.4-281.2-166.8-372.7C774.6 88.4 706.1 66 632.8 66c-119 0-225.6 59.1-297.4 152.2z",
                fill: "url(#b)"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 25099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ZapCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92052);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  place-content: center;\n  background: ",
        ";\n  border-radius: 8px 0px 0px 0px;\n  border: 1px solid ",
        ";\n  border-right: none;\n  width: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ZapCheckBoxWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-4a3af06d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ZapCheckbox = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ZapCheckBoxWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            scale: "sm"
        }, props))
    });
};


/***/ }),

/***/ 46882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UnsupportedCurrencyFooter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85937);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98768);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21812);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52775);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30445);
/* harmony import */ var components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(941);
/* harmony import */ var components_Logo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19259);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97477);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97119);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73938);
/* harmony import */ var _hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41166);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 0;\n  width: 100%;\n  max-width: 400px;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  color: ",
        ";\n  background-color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var DetailsFooter = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-14e16177-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
});
var UnsupportedModal = function(param) {
    var currencies = param.currencies, onDismiss = param.onDismiss;
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().chainId;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var tokens = chainId && currencies ? currencies.map(function(currency) {
        return (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_8__/* .wrappedCurrency */ .pu)(currency, chainId);
    }) : [];
    var unsupportedTokens = (0,_hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__/* .useUnsupportedTokens */ .l6)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        title: t("Unsupported Assets"),
        maxWidth: "420px",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
            gap: "lg",
            children: [
                tokens.map(function(token) {
                    var ref;
                    return token && unsupportedTokens && Object.keys(unsupportedTokens).includes(token.address) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                        gap: "10px",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__/* .AutoRow */ .BA, {
                                gap: "5px",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_5__/* .CurrencyLogo */ .Xw, {
                                        currency: token,
                                        size: "24px"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        children: token.symbol
                                    })
                                ]
                            }),
                            chainId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                external: true,
                                small: true,
                                color: "primaryDark",
                                href: (0,utils__WEBPACK_IMPORTED_MODULE_7__/* .getBlockExploreLink */ .C)(token.address, "address", chainId),
                                children: token.address
                            })
                        ]
                    }, (ref = token.address) === null || ref === void 0 ? void 0 : ref.concat("not-supported"));
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                    gap: "lg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: t("Some assets are not available through this interface because they may not work well with our smart contract or we are unable to allow trading for legal reasons.")
                    })
                })
            ]
        })
    });
};
function UnsupportedCurrencyFooter(param) {
    var currencies = param.currencies;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UnsupportedModal, {
        currencies: currencies
    })), 1), onPresentModal = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DetailsFooter, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            variant: "text",
            onClick: onPresentModal,
            children: t("Read more about unsupported assets")
        })
    });
};


/***/ }),

/***/ 20458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _currency_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/wagmi.ts + 9 modules
var wagmi = __webpack_require__(81103);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var src = __webpack_require__(46472);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(21812);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(70257);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(27208);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(96484);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(94998);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(70486);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(94293);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(52775);
// EXTERNAL MODULE: ./src/components/UnsupportedCurrencyFooter.tsx
var UnsupportedCurrencyFooter = __webpack_require__(46882);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(8414);
// EXTERNAL MODULE: ./src/components/CommitButton.tsx
var CommitButton = __webpack_require__(52036);
// EXTERNAL MODULE: ./src/utils/getLpSymbol.ts
var getLpSymbol = __webpack_require__(54146);
// EXTERNAL MODULE: ./src/hooks/useNativeCurrency.ts
var useNativeCurrency = __webpack_require__(19915);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/calls/index.ts + 2 modules
var calls = __webpack_require__(56946);
// EXTERNAL MODULE: ./src/config/constants/supportChains.ts
var supportChains = __webpack_require__(80692);
// EXTERNAL MODULE: ./src/utils/transactionErrorToUserReadableMessage.ts
var transactionErrorToUserReadableMessage = __webpack_require__(78809);
// EXTERNAL MODULE: ./src/state/swap/hooks.ts + 13 modules
var hooks = __webpack_require__(47455);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 5 modules
var tokens_src = __webpack_require__(40370);
// EXTERNAL MODULE: ./src/components/Card/index.tsx
var Card = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(941);
// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/index.tsx + 1 modules
var CurrencyInputPanel = __webpack_require__(53258);
// EXTERNAL MODULE: ./src/components/App/index.tsx + 3 modules
var App = __webpack_require__(88254);
// EXTERNAL MODULE: ./src/components/PositionCard/index.tsx
var PositionCard = __webpack_require__(26688);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(30445);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx + 1 modules
var ConnectWalletButton = __webpack_require__(72409);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(71633);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(41166);
// EXTERNAL MODULE: ./src/hooks/useApproveCallback.ts + 2 modules
var useApproveCallback = __webpack_require__(36585);
// EXTERNAL MODULE: ./src/hooks/useTransactionDeadline.ts
var useTransactionDeadline = __webpack_require__(99634);
// EXTERNAL MODULE: ./src/state/mint/actions.ts
var actions = __webpack_require__(21568);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(75759);
// EXTERNAL MODULE: ./packages/hooks/src/index.ts + 4 modules
var hooks_src = __webpack_require__(74903);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(22408);
// EXTERNAL MODULE: ./src/hooks/useTotalSupply.ts
var useTotalSupply = __webpack_require__(19639);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(17937);
// EXTERNAL MODULE: ./packages/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(68492);
// EXTERNAL MODULE: ./src/state/index.ts + 31 modules
var state = __webpack_require__(2154);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(5460);
;// CONCATENATED MODULE: ./src/state/mint/hooks.ts
























function useMintState() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.mint;
    });
}
function useMintActionHandlers(noLiquidity) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var onFieldAInput = (0,react.useCallback)(function(typedValue) {
        dispatch((0,actions/* typeInput */.LC)({
            field: actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
            typedValue: typedValue,
            noLiquidity: noLiquidity === true
        }));
    }, [
        dispatch,
        noLiquidity
    ]);
    var onFieldBInput = (0,react.useCallback)(function(typedValue) {
        dispatch((0,actions/* typeInput */.LC)({
            field: actions/* Field.CURRENCY_B */.gN.CURRENCY_B,
            typedValue: typedValue,
            noLiquidity: noLiquidity === true
        }));
    }, [
        dispatch,
        noLiquidity
    ]);
    return {
        onFieldAInput: onFieldAInput,
        onFieldBInput: onFieldBInput
    };
}
function useDerivedMintInfo(currencyA, currencyB) {
    var ref, ref1, ref2, ref3;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref4 = useMintState(), independentField = ref4.independentField, typedValue = ref4.typedValue, otherTypedValue = ref4.otherTypedValue;
    var dependentField = independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A;
    // tokens
    var currencies = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    // pair
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,usePairs/* usePair */.yX)(currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]), 2), pairState = ref5[0], pair = ref5[1];
    var totalSupply = (0,useTotalSupply/* default */.Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    var noLiquidity = pairState === usePairs/* PairState.NOT_EXISTS */._G.NOT_EXISTS || Boolean(totalSupply && src/* JSBI.equal */.QA.equal(totalSupply.quotient, exchange/* BIG_INT_ZERO */.iV)) || Boolean(pairState === usePairs/* PairState.EXISTS */._G.EXISTS && pair && src/* JSBI.equal */.QA.equal(pair.reserve0.quotient, exchange/* BIG_INT_ZERO */.iV) && src/* JSBI.equal */.QA.equal(pair.reserve1.quotient, exchange/* BIG_INT_ZERO */.iV));
    // balances
    var balances = (0,wallet_hooks/* useCurrencyBalances */.K5)(account !== null && account !== void 0 ? account : undefined, [
        currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
        currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], 
    ]);
    var _obj;
    var currencyBalances = (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, balances[0]), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, balances[1]), _obj);
    // amounts
    var independentAmount = (0,tryParseAmount/* default */.Z)(typedValue, currencies[independentField]);
    var dependentAmount = (0,react.useMemo)(function() {
        if (noLiquidity) {
            if (otherTypedValue && currencies[dependentField]) {
                return (0,tryParseAmount/* default */.Z)(otherTypedValue, currencies[dependentField]);
            }
            return undefined;
        }
        if (independentAmount) {
            // we wrap the currencies just to get the price in terms of the other token
            var wrappedIndependentAmount = independentAmount === null || independentAmount === void 0 ? void 0 : independentAmount.wrapped;
            var ref = [
                currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
                currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
            ], tokenA = ref[0], tokenB = ref[1];
            if (tokenA && tokenB && wrappedIndependentAmount && pair) {
                var dependentCurrency = dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? currencyB : currencyA;
                var dependentTokenAmount = dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedIndependentAmount) : pair.priceOf(tokenB).quote(wrappedIndependentAmount);
                return (dependentCurrency === null || dependentCurrency === void 0 ? void 0 : dependentCurrency.isNative) ? src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(dependentCurrency, dependentTokenAmount.quotient) : dependentTokenAmount;
            }
            return undefined;
        }
        return undefined;
    }, [
        noLiquidity,
        otherTypedValue,
        currencies,
        dependentField,
        independentAmount,
        currencyA,
        currencyB,
        pair
    ]);
    var parsedAmounts = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField
    ]);
    var price = (0,react.useMemo)(function() {
        if (noLiquidity) {
            var currencyAAmount = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], currencyBAmount = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
            if (currencyAAmount && currencyBAmount) {
                return new src/* Price */.tA(currencyAAmount.currency, currencyBAmount.currency, currencyAAmount.quotient, currencyBAmount.quotient);
            }
            return undefined;
        }
        var wrappedCurrencyA = currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped;
        return pair && wrappedCurrencyA ? pair.priceOf(wrappedCurrencyA) : undefined;
    }, [
        currencyA,
        noLiquidity,
        pair,
        parsedAmounts
    ]);
    // liquidity minted
    var liquidityMinted = (0,react.useMemo)(function() {
        var currencyAAmount = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], currencyBAmount = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
        var ref = [
            currencyAAmount === null || currencyAAmount === void 0 ? void 0 : currencyAAmount.wrapped,
            currencyBAmount === null || currencyBAmount === void 0 ? void 0 : currencyBAmount.wrapped
        ], tokenAmountA = ref[0], tokenAmountB = ref[1];
        if (pair && totalSupply && tokenAmountA && tokenAmountB) {
            try {
                return pair.getLiquidityMinted(totalSupply, tokenAmountA, tokenAmountB);
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        parsedAmounts,
        pair,
        totalSupply
    ]);
    var poolTokenPercentage = (0,react.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new src/* Percent */.gG(liquidityMinted.quotient, totalSupply.add(liquidityMinted).quotient);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var error;
    var addError;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (pairState === usePairs/* PairState.INVALID */._G.INVALID) {
        error = error !== null && error !== void 0 ? error : t("Choose a valid pair");
    }
    var currencyAAmount = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], currencyBAmount = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
    if (currencyAAmount && currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.equalTo(0)) && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref1 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.equalTo(0))) {
        error = error !== null && error !== void 0 ? error : t("No token balance");
    }
    if (!parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] || !parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) {
        addError = t("Enter an amount");
    }
    if (currencyAAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref2 = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(currencyAAmount))) {
        var ref6;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref6 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref6 === void 0 ? void 0 : ref6.symbol
        });
    }
    if (currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref3 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(currencyBAmount))) {
        var ref7;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref7 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref7 === void 0 ? void 0 : ref7.symbol
        });
    }
    return {
        dependentField: dependentField,
        currencies: currencies,
        pair: pair,
        pairState: pairState,
        currencyBalances: currencyBalances,
        parsedAmounts: parsedAmounts,
        price: price,
        noLiquidity: noLiquidity,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        error: error,
        addError: addError
    };
}
var MAX_ZAP_REVERSE_RATIO = src/* JSBI.BigInt */.QA.BigInt(50);
var getMaxZapSwapAmount = function(pair, tokenZap) {
    return pair && tokenZap && pair.involvesToken(tokenZap) && src/* JSBI.divide */.QA.divide(pair.reserveOf(tokenZap).quotient, MAX_ZAP_REVERSE_RATIO);
};
// simplify version to guess the zap in amount by swapInAmount from max zap reserves ratio 50
function guessMaxZappableAmount(pair, token0AmountIn, token1AmountIn) {
    if (!token1AmountIn) {
        if (token0AmountIn) {
            var maxSwapAmount = getMaxZapSwapAmount(pair, token0AmountIn.currency);
            return maxSwapAmount && src/* JSBI.multiply */.QA.multiply(maxSwapAmount, src/* JSBI.BigInt */.QA.BigInt(2));
        }
        return undefined;
    }
    if (token0AmountIn && token1AmountIn) {
        var maxSwapAmount1 = getMaxZapSwapAmount(pair, token0AmountIn.currency);
        if (!maxSwapAmount1) {
            return undefined;
        }
        var ref = (0,_sliced_to_array/* default */.Z)(pair.getInputAmount(src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(token0AmountIn.currency, maxSwapAmount1)), 2), _ = ref[0], newPair = ref[1];
        return src/* JSBI.add */.QA.add(maxSwapAmount1, src/* JSBI.divide */.QA.divide(src/* JSBI.multiply */.QA.multiply(token1AmountIn.quotient, newPair.reserveOf(token0AmountIn.currency).quotient), newPair.reserveOf(token1AmountIn.currency).quotient));
    }
    return undefined;
}
// compare the gas is larger than swap in amount
function useZapInGasOverhead(inputAmount) {
    var ref;
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var native = (0,useNativeCurrency/* default */.Z)();
    var requiredGas = (0,lib_esm.formatUnits)(gasPrice ? bignumber/* BigNumber.from */.O$.from(gasPrice).mul("500000") : "0");
    var requiredGasAsCurrencyAmount = inputAmount ? (0,tryParseAmount/* default */.Z)(requiredGas, native) : undefined;
    var inputIsBNB = (inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency.symbol) === "BNB";
    var gasCostInInputTokens = (0,Trades/* useTradeExactIn */.AU)(requiredGasAsCurrencyAmount, inputIsBNB ? null : inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency);
    var ref1;
    return (ref1 = gasCostInInputTokens === null || gasCostInInputTokens === void 0 ? void 0 : (ref = gasCostInInputTokens.outputAmount) === null || ref === void 0 ? void 0 : ref.greaterThan(inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.quotient)) !== null && ref1 !== void 0 ? ref1 : false;
}
function useZapIn(param) {
    var canZap = param.canZap, currencyA = param.currencyA, currencyB = param.currencyB, pair = param.pair, currencyBalances = param.currencyBalances, zapTokenCheckedA = param.zapTokenCheckedA, zapTokenCheckedB = param.zapTokenCheckedB, maxAmounts = param.maxAmounts;
    var ref, ref1, ref2, ref3;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref4 = (0,react.useState)(false), inputBlurOnce = ref4[0], setInputBlurOnce = ref4[1];
    var previousBlur = (0,hooks_src/* usePreviousValue */.zP)(inputBlurOnce);
    var ref5 = (0,react.useState)(false), triedAutoReduce = ref5[0], setTriedAutoReduce = ref5[1];
    var ref6 = useMintState(), independentField = ref6.independentField, typedValue = ref6.typedValue;
    var dependentField = independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A;
    var currencies = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    var independentAmount = (0,tryParseAmount/* default */.Z)(typedValue, currencies[independentField]);
    var _dependentAmount = (0,react.useMemo)(function() {
        if (!canZap) {
            return undefined;
        }
        if (independentAmount) {
            var wrappedIndependentAmount = independentAmount === null || independentAmount === void 0 ? void 0 : independentAmount.wrapped;
            var ref = [
                currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
                currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
            ], tokenA = ref[0], tokenB = ref[1];
            if (tokenA && tokenB && wrappedIndependentAmount && pair) {
                var dependentCurrency = dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? currencyB : currencyA;
                var dependentTokenAmount = dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedIndependentAmount) : pair.priceOf(tokenB).quote(wrappedIndependentAmount);
                return dependentCurrency.isNative ? src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(dependentCurrency, dependentTokenAmount.quotient) : dependentTokenAmount;
            }
            return undefined;
        }
        return undefined;
    }, [
        canZap,
        currencyA,
        currencyB,
        dependentField,
        independentAmount,
        pair
    ]);
    var isDependentAmountGreaterThanMaxAmount = maxAmounts[dependentField] && _dependentAmount && (_dependentAmount === null || _dependentAmount === void 0 ? void 0 : _dependentAmount.greaterThan(maxAmounts[dependentField]));
    // amounts
    var dependentAmount = (0,react.useMemo)(function() {
        return isDependentAmountGreaterThanMaxAmount ? maxAmounts[dependentField] : _dependentAmount;
    }, [
        isDependentAmountGreaterThanMaxAmount,
        maxAmounts,
        dependentField,
        _dependentAmount
    ]);
    var parsedAmounts = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, !zapTokenCheckedA ? undefined : independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, !zapTokenCheckedB ? undefined : independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField,
        zapTokenCheckedA,
        zapTokenCheckedB
    ]);
    var wrappedParsedAmounts = (0,react.useMemo)(function() {
        var ref, ref1;
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, (ref = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.wrapped), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, (ref1 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.wrapped), _obj;
    }, [
        parsedAmounts
    ]);
    var zapContract = (0,useContract/* useZapContract */.n9)();
    var rebalancing = !!zapTokenCheckedA && !!zapTokenCheckedB && !!parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && !!parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
    var singleTokenToZapField = !rebalancing && zapTokenCheckedB && !!parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A;
    var singleTokenToZapAmount = (0,react.useMemo)(function() {
        return wrappedParsedAmounts[singleTokenToZapField];
    }, [
        singleTokenToZapField,
        wrappedParsedAmounts
    ]);
    var noNeedZap = (0,react.useMemo)(function() {
        if (!rebalancing) {
            return false;
        }
        if (!wrappedParsedAmounts[independentField] || !wrappedParsedAmounts[dependentField]) {
            return undefined;
        }
        if (!isDependentAmountGreaterThanMaxAmount) {
            return true;
        }
        var ref = [
            currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
            currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
        ], tokenA = ref[0], tokenB = ref[1];
        if (tokenA && tokenB && wrappedParsedAmounts[independentField] && pair) {
            return wrappedParsedAmounts[dependentField].equalTo(dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedParsedAmounts[independentField]) : pair.priceOf(tokenB).quote(wrappedParsedAmounts[independentField]));
        }
        return undefined;
    }, [
        currencyA,
        currencyB,
        dependentField,
        independentField,
        isDependentAmountGreaterThanMaxAmount,
        pair,
        rebalancing,
        wrappedParsedAmounts, 
    ]);
    var singleZapEstimate = (0,useSWRContract/* useSWRContract */.Av)(canZap && !noNeedZap && zapContract && singleTokenToZapAmount && (singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.currency) && pair && !rebalancing && {
        contract: zapContract,
        methodName: "estimateZapInSwap",
        params: [
            singleTokenToZapAmount.currency.address,
            singleTokenToZapAmount.quotient.toString(),
            pair.liquidityToken.address, 
        ]
    }, {
        onError: function onError(err) {
            console.error(err);
        }
    });
    var rebalancingZapEstimate = (0,useSWRContract/* useSWRContract */.Av)(canZap && zapContract && !noNeedZap && wrappedParsedAmounts && wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] && pair && rebalancing && {
        contract: zapContract,
        methodName: "estimateZapInRebalancingSwap",
        params: [
            wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].currency.address,
            wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].currency.address,
            wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].quotient.toString(),
            (ref = wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : (ref1 = ref.quotient) === null || ref1 === void 0 ? void 0 : ref1.toString(),
            pair.liquidityToken.address, 
        ]
    }, {
        onError: function onError(err) {
            console.error(err);
        }
    });
    var zapInEstimated = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return ((rebalancingZapEstimate === null || rebalancingZapEstimate === void 0 ? void 0 : rebalancingZapEstimate.data) || (singleZapEstimate === null || singleZapEstimate === void 0 ? void 0 : singleZapEstimate.data)) && {
            swapAmountIn: rebalancing ? (ref = rebalancingZapEstimate.data) === null || ref === void 0 ? void 0 : ref.swapAmountIn : (ref1 = singleZapEstimate.data) === null || ref1 === void 0 ? void 0 : ref1.swapAmountIn,
            swapAmountOut: rebalancing ? (ref2 = rebalancingZapEstimate.data) === null || ref2 === void 0 ? void 0 : ref2.swapAmountOut : (ref3 = singleZapEstimate.data) === null || ref3 === void 0 ? void 0 : ref3.swapAmountOut,
            isToken0Sold: rebalancing ? (ref4 = rebalancingZapEstimate.data) === null || ref4 === void 0 ? void 0 : ref4.sellToken0 : ((ref5 = singleZapEstimate.data) === null || ref5 === void 0 ? void 0 : ref5.swapTokenOut) === (singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.currency.address)
        };
    }, [
        rebalancing,
        rebalancingZapEstimate.data,
        singleZapEstimate.data,
        singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.currency.address
    ]);
    var rebalancingSellToken0 = (0,react.useMemo)(function() {
        if (rebalancingZapEstimate.data) {
            return rebalancingZapEstimate.data.sellToken0;
        }
        if (!pair || !wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] || !wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) {
            return undefined;
        }
        var token0toZap = pair.token0.equals(wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].currency);
        if (token0toZap) {
            return src/* JSBI.greaterThan */.QA.greaterThan(src/* JSBI.multiply */.QA.multiply(wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].quotient, pair.reserve1.quotient), src/* JSBI.multiply */.QA.multiply(wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].quotient, pair.reserve0.quotient));
        }
        return src/* JSBI.greaterThan */.QA.greaterThan(src/* JSBI.multiply */.QA.multiply(wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].quotient, pair.reserve0.quotient), src/* JSBI.multiply */.QA.multiply(wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].quotient, pair.reserve1.quotient));
    }, [
        pair,
        rebalancingZapEstimate.data,
        wrappedParsedAmounts
    ]);
    var swapTokenField = !rebalancing ? singleTokenToZapField : rebalancingSellToken0 ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B;
    var swapOutTokenField = swapTokenField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A;
    var swapTokens = (0,react.useMemo)(function() {
        var ref, ref1;
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, swapTokenField, (ref = currencies[swapTokenField]) === null || ref === void 0 ? void 0 : ref.wrapped), (0,_define_property/* default */.Z)(_obj, swapOutTokenField, (ref1 = currencies[swapOutTokenField]) === null || ref1 === void 0 ? void 0 : ref1.wrapped), _obj;
    }, [
        currencies,
        swapOutTokenField,
        swapTokenField
    ]);
    var zapInEstimatedError = (0,react.useMemo)(function() {
        return rebalancing ? rebalancingZapEstimate.error : singleZapEstimate.error;
    }, [
        rebalancing,
        rebalancingZapEstimate.error,
        singleZapEstimate.error
    ]);
    var zapInEstimatedStatus = (0,react.useMemo)(function() {
        return rebalancing ? rebalancingZapEstimate.status : singleZapEstimate.status;
    }, [
        rebalancing,
        rebalancingZapEstimate.status,
        singleZapEstimate.status
    ]);
    var priceImpact = (0,react.useMemo)(function() {
        if (!zapInEstimated) {
            return undefined;
        }
        var tokenAmountIn = src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString());
        var tokenAmountOut = src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(swapTokens[swapOutTokenField], zapInEstimated.swapAmountOut.toString());
        var midPrice = new src/* Price */.tA(swapTokens[swapTokenField], swapTokens[swapOutTokenField], pair.token0.equals(swapTokens[swapTokenField]) ? pair.reserve0.quotient : pair.reserve1.quotient, pair.token0.equals(swapTokens[swapTokenField]) ? pair.reserve1.quotient : pair.reserve0.quotient);
        return (0,src/* computePriceImpact */.oc)(midPrice, tokenAmountIn, tokenAmountOut);
    }, [
        pair,
        swapOutTokenField,
        swapTokenField,
        swapTokens,
        zapInEstimated
    ]);
    var overLimitZapRatio = (0,react.useMemo)(function() {
        if (!zapInEstimated) {
            return false;
        }
        return src/* JSBI.lessThan */.QA.lessThan(src/* JSBI.divide */.QA.divide(pair.reserveOf(swapTokens[swapTokenField]).quotient, src/* JSBI.BigInt */.QA.BigInt(zapInEstimated.swapAmountIn.toString())), MAX_ZAP_REVERSE_RATIO);
    }, [
        pair,
        swapTokens,
        zapInEstimated,
        swapTokenField
    ]);
    var priceSeverity = overLimitZapRatio || zapInEstimatedError ? 4 : priceImpact ? (0,utils_exchange/* warningSeverity */.oX)(priceImpact) : 0;
    var ref7 = useMintActionHandlers(false), onFieldAInput = ref7.onFieldAInput, onFieldBInput = ref7.onFieldBInput;
    var maxZappableAmount = (0,react.useMemo)(function() {
        return guessMaxZappableAmount(pair, wrappedParsedAmounts[swapTokenField], rebalancing ? wrappedParsedAmounts[swapOutTokenField] : undefined);
    }, [
        pair,
        wrappedParsedAmounts,
        swapTokenField,
        rebalancing,
        swapOutTokenField
    ]);
    var convertToMaxZappable = (0,react.useCallback)(function() {
        if (maxZappableAmount) {
            if (maxAmounts[swapTokenField]) {
                var ref;
                var formatInput = (0,lib_esm.formatUnits)(src/* JSBI.greaterThan */.QA.greaterThan(maxAmounts[swapTokenField].quotient, maxZappableAmount) ? maxZappableAmount.toString() : maxAmounts[swapTokenField].quotient.toString(), (ref = maxAmounts[swapTokenField]) === null || ref === void 0 ? void 0 : ref.currency.decimals);
                if (swapTokenField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A) {
                    onFieldAInput(formatInput);
                } else {
                    onFieldBInput(formatInput);
                }
            }
        }
    }, [
        maxAmounts,
        maxZappableAmount,
        onFieldAInput,
        onFieldBInput,
        swapTokenField
    ]);
    var totalSupply = (0,useTotalSupply/* default */.Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    // liquidity minted
    var liquidityMinted = (0,react.useMemo)(function() {
        if (!pair || !swapTokens[swapTokenField] || !swapTokens[swapOutTokenField] || !(zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountIn) || !(zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut) || !wrappedParsedAmounts[swapTokenField]) {
            return undefined;
        }
        if (pair && totalSupply) {
            try {
                // calc the tokenA amount after swap
                var zappedTokenAmountA = wrappedParsedAmounts[swapTokenField].greaterThan(zapInEstimated.swapAmountIn.toString()) ? wrappedParsedAmounts[swapTokenField].subtract(src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString())) : wrappedParsedAmounts[swapTokenField];
                var zappedTokenAmountB = src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(swapTokens[swapOutTokenField], zapInEstimated.swapAmountOut.toString());
                if (wrappedParsedAmounts[swapOutTokenField]) {
                    zappedTokenAmountB = zappedTokenAmountB.add(wrappedParsedAmounts[swapOutTokenField]);
                }
                var lpMinted = pair.getLiquidityMinted(totalSupply, zappedTokenAmountA, zappedTokenAmountB);
                return lpMinted;
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        pair,
        swapTokens,
        swapTokenField,
        swapOutTokenField,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountIn,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut,
        wrappedParsedAmounts,
        totalSupply, 
    ]);
    var swapTokenAmountTooLow = (0,react.useMemo)(function() {
        return wrappedParsedAmounts[swapTokenField] && src/* JSBI.lessThan */.QA.lessThan(wrappedParsedAmounts[swapTokenField].quotient, src/* MINIMUM_LIQUIDITY */.Xh);
    }, [
        swapTokenField,
        wrappedParsedAmounts
    ]);
    var swapOutAmountTooLow = (0,react.useMemo)(function() {
        return wrappedParsedAmounts[swapOutTokenField] && src/* JSBI.lessThan */.QA.lessThan(wrappedParsedAmounts[swapOutTokenField].quotient, src/* MINIMUM_LIQUIDITY */.Xh);
    }, [
        swapOutTokenField,
        wrappedParsedAmounts
    ]);
    var poolTokenPercentage = (0,react.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new src/* Percent */.gG(liquidityMinted.quotient, totalSupply.add(liquidityMinted).quotient);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var gasOverhead = useZapInGasOverhead((0,react.useMemo)(function() {
        return zapInEstimated ? src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString()) : null;
    }, [
        swapTokenField,
        swapTokens,
        zapInEstimated
    ]));
    (0,react.useEffect)(function() {
        if (!triedAutoReduce && parsedAmounts[swapTokenField] && maxZappableAmount && !previousBlur && inputBlurOnce && !rebalancing) {
            if (src/* JSBI.greaterThan */.QA.greaterThan(parsedAmounts[swapTokenField].quotient, maxZappableAmount)) {
                convertToMaxZappable();
                setTriedAutoReduce(true);
            }
        }
    }, [
        convertToMaxZappable,
        inputBlurOnce,
        maxZappableAmount,
        parsedAmounts,
        previousBlur,
        rebalancing,
        singleTokenToZapAmount,
        swapTokenField,
        triedAutoReduce, 
    ]);
    var onInputBlurOnce = (0,react.useCallback)(function() {
        setInputBlurOnce(true);
    }, []);
    var error;
    if (zapInEstimatedError) {
        error = t("Cannot estimate zap amount");
    }
    if (swapTokenAmountTooLow || rebalancing && swapOutAmountTooLow) {
        error = t("Zap in amount too low");
    }
    if (wrappedParsedAmounts[swapTokenField] && ((ref2 = currencyBalances[swapTokenField]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(wrappedParsedAmounts[swapTokenField]))) {
        var ref8;
        var _symbol;
        error = t("Insufficient %token% balance", {
            token: (_symbol = (ref8 = wrappedParsedAmounts[swapTokenField]) === null || ref8 === void 0 ? void 0 : ref8.currency.symbol) !== null && _symbol !== void 0 ? _symbol : ""
        });
    }
    if (wrappedParsedAmounts[swapOutTokenField] && rebalancing && ((ref3 = currencyBalances[swapOutTokenField]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(wrappedParsedAmounts[swapOutTokenField]))) {
        var ref9;
        var _symbol1;
        error = t("Insufficient %token% balance", {
            token: (_symbol1 = (ref9 = wrappedParsedAmounts[swapOutTokenField]) === null || ref9 === void 0 ? void 0 : ref9.currency.symbol) !== null && _symbol1 !== void 0 ? _symbol1 : ""
        });
    }
    return {
        zapInEstimating: zapInEstimatedStatus !== types/* FetchStatus.Fetched */.iF.Fetched,
        zapInEstimatedError: zapInEstimatedError,
        zapInEstimated: zapInEstimated,
        error: error,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        parsedAmounts: parsedAmounts,
        swapTokenField: swapTokenField,
        swapOutTokenField: swapOutTokenField,
        priceSeverity: priceSeverity,
        convertToMaxZappable: convertToMaxZappable,
        rebalancing: rebalancing,
        noNeedZap: noNeedZap,
        gasOverhead: gasOverhead,
        isDependentAmountGreaterThanMaxAmount: isDependentAmountGreaterThanMaxAmount,
        onInputBlurOnce: onInputBlurOnce
    };
}

// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(56906);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/utils/maxAmountSpend.ts
var maxAmountSpend = __webpack_require__(11372);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(73938);
// EXTERNAL MODULE: ./src/components/Loader/Dots.tsx
var Dots = __webpack_require__(32519);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/PoolPriceBar.tsx







function PoolPriceBar(param) {
    var currencies = param.currencies, noLiquidity = param.noLiquidity, poolTokenPercentage = param.poolTokenPercentage, price = param.price;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
        gap: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
            justify: "space-around",
            gap: "4px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (ref5 = price === null || price === void 0 ? void 0 : price.toSignificant(6)) !== null && ref5 !== void 0 ? ref5 : "-"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            pt: 1,
                            children: t("%assetA% per %assetB%", {
                                assetA: (ref6 = (ref = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : ref.symbol) !== null && ref6 !== void 0 ? ref6 : "",
                                assetB: (ref7 = (ref1 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.symbol) !== null && ref7 !== void 0 ? ref7 : ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (ref8 = (ref2 = price === null || price === void 0 ? void 0 : price.invert()) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(6)) !== null && ref8 !== void 0 ? ref8 : "-"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            pt: 1,
                            children: t("%assetA% per %assetB%", {
                                assetA: (ref9 = (ref3 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref3 === void 0 ? void 0 : ref3.symbol) !== null && ref9 !== void 0 ? ref9 : "",
                                assetB: (ref10 = (ref4 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref4 === void 0 ? void 0 : ref4.symbol) !== null && ref10 !== void 0 ? ref10 : ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                noLiquidity && price ? "100" : (ref11 = (poolTokenPercentage === null || poolTokenPercentage === void 0 ? void 0 : poolTokenPercentage.lessThan(exchange/* ONE_BIPS */.IS)) ? "<0.01" : poolTokenPercentage === null || poolTokenPercentage === void 0 ? void 0 : poolTokenPercentage.toFixed(2)) !== null && ref11 !== void 0 ? ref11 : "0",
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            pt: 1,
                            children: t("Share of Pool")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var AddLiquidity_PoolPriceBar = (PoolPriceBar);

// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(26118);
// EXTERNAL MODULE: ./src/components/TransactionConfirmationModal/index.tsx
var TransactionConfirmationModal = __webpack_require__(38695);
// EXTERNAL MODULE: ./src/state/burn/actions.ts
var burn_actions = __webpack_require__(54820);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(44976);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(19259);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/components/common.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var Dot = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-beab1544-0"
})(_templateObject());
var CircleSvg = function(_param) /*#__PURE__*/ {
    var _percent = _param.percent, percent = _percent === void 0 ? 1 : _percent, props = (0,_object_without_properties/* default */.Z)(_param, [
        "percent"
    ]);
    return (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "60px",
        height: "60px",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_i_1147_113741)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        r: "10",
                        cx: "10",
                        cy: "10",
                        fill: "#7645D9"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        r: "5",
                        cx: "10",
                        cy: "10",
                        fill: "transparent",
                        stroke: "#1FC7D4",
                        strokeWidth: "10",
                        strokeDasharray: "calc(".concat(percent * 100, "px * 31.4 / 100) 31.4"),
                        transform: "rotate(-90) translate(-20)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_i_1147_113741",
                    x: 0,
                    y: 0,
                    width: 60,
                    height: 60,
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: -2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: -1,
                            k3: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in2: "shape",
                            result: "effect1_innerShadow_1147_113741"
                        })
                    ]
                })
            })
        ]
    }));
};
var Subtitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        fontSize: "12px",
        textTransform: "uppercase",
        bold: true,
        color: "secondary",
        children: children
    });
};
var PairDistribution = function(param) {
    var title = param.title, percent = param.percent, currencyA = param.currencyA, currencyB = param.currencyB, currencyAValue = param.currencyAValue, currencyBValue = param.currencyBValue, tooltipTargetRef = param.tooltipTargetRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "8px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    typeof percent !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: tooltipTargetRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleSvg, {
                            percent: percent,
                            mr: "34px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                        style: {
                            width: "100%"
                        },
                        children: [
                            currencyA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                        gap: "4px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                                bg: "primary"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                                currency: currencyA
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: currencyAValue
                                    })
                                ]
                            }),
                            currencyB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                        gap: "4px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                                bg: "secondary"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                                currency: currencyB
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: currencyBValue
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var AddLiquidityModalHeader = function(param) {
    var currencies = param.currencies, poolTokenPercentage = param.poolTokenPercentage, liquidityMinted = param.liquidityMinted, price = param.price, allowedSlippage = param.allowedSlippage, noLiquidity = param.noLiquidity, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref8 = (0,useTooltip/* default */.Z)(t("Output is estimated. If the price changes by more than %slippage%% your transaction will revert.", {
        slippage: allowedSlippage / 100
    }), {
        placement: "auto"
    }), tooltip = ref8.tooltip, tooltipVisible = ref8.tooltipVisible, targetRef = ref8.targetRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "24px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("You will receive")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* GreyCard */.h2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                    gap: "4px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* DoubleCurrencyLogo */.ge, {
                                            currency0: currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A],
                                            currency1: currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B],
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "textSubtle",
                                            children: ((ref = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.symbol) && ((ref1 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.symbol) && (0,getLpSymbol/* getLPSymbol */.z)((ref2 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.symbol, (ref3 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.symbol)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    ml: "8px",
                                    children: liquidityMinted === null || liquidityMinted === void 0 ? void 0 : liquidityMinted.toSignificant(6)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("Your pool share")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            noLiquidity ? "100" : poolTokenPercentage === null || poolTokenPercentage === void 0 ? void 0 : poolTokenPercentage.toSignificant(4),
                            "%"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                gap: "8px",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                children: t("Rates")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "1 ".concat((ref4 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref4 === void 0 ? void 0 : ref4.symbol, " = ").concat(price === null || price === void 0 ? void 0 : price.toSignificant(4), " ").concat((ref5 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref5 === void 0 ? void 0 : ref5.symbol)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                        style: {
                            justifyContent: "flex-end"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "1 ".concat((ref6 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref6 === void 0 ? void 0 : ref6.symbol, " = ").concat(price === null || price === void 0 ? void 0 : price.invert().toSignificant(4), " ").concat((ref7 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref7 === void 0 ? void 0 : ref7.symbol)
                        })
                    })
                ]
            }),
            !noLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("Slippage Tolerance")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipText/* default */.Z, {
                        ref: targetRef,
                        children: [
                            allowedSlippage / 100,
                            "%"
                        ]
                    }),
                    tooltipVisible && tooltip
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/AddLiquidity/components/ConfirmAddLiquidityModal.tsx







var ConfirmAddLiquidityModal = function(param) {
    var title = param.title, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, attemptingTxn = param.attemptingTxn, hash = param.hash, pendingText = param.pendingText, price = param.price, currencies = param.currencies, noLiquidity = param.noLiquidity, allowedSlippage = param.allowedSlippage, parsedAmounts = param.parsedAmounts, liquidityErrorMessage = param.liquidityErrorMessage, onAdd = param.onAdd, poolTokenPercentage = param.poolTokenPercentage, liquidityMinted = param.liquidityMinted, currencyToAdd = param.currencyToAdd;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var modalHeader = (0,react.useCallback)(function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddLiquidityModalHeader, {
            allowedSlippage: allowedSlippage,
            currencies: currencies,
            liquidityMinted: liquidityMinted,
            poolTokenPercentage: poolTokenPercentage,
            price: price,
            noLiquidity: noLiquidity,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PairDistribution, {
                title: t("Input"),
                percent: 0.5,
                currencyA: currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A],
                currencyAValue: (ref = parsedAmounts[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toSignificant(6),
                currencyB: currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B],
                currencyBValue: (ref1 = parsedAmounts[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)
            })
        });
    }, [
        allowedSlippage,
        currencies,
        liquidityMinted,
        noLiquidity,
        parsedAmounts,
        poolTokenPercentage,
        price,
        t
    ]);
    var modalBottom = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: "100%",
            onClick: onAdd,
            mt: "20px",
            children: noLiquidity ? t("Create Pool & Supply") : t("Confirm Supply")
        });
    }, [
        noLiquidity,
        onAdd,
        t
    ]);
    var confirmationContent = (0,react.useCallback)(function() {
        return liquidityErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
            onDismiss: onDismiss,
            message: liquidityErrorMessage
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* ConfirmationModalContent */.pM, {
            topContent: modalHeader,
            bottomContent: modalBottom
        });
    }, [
        onDismiss,
        modalBottom,
        modalHeader,
        liquidityErrorMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* default */.ZP, {
        minWidth: [
            "100%",
            ,
            "420px"
        ],
        title: title,
        onDismiss: onDismiss,
        customOnDismiss: customOnDismiss,
        attemptingTxn: attemptingTxn,
        currencyToAdd: currencyToAdd,
        hash: hash,
        content: confirmationContent,
        pendingText: pendingText
    });
};
/* harmony default export */ var components_ConfirmAddLiquidityModal = (ConfirmAddLiquidityModal);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(45203);
// EXTERNAL MODULE: ./src/views/AddLiquidity/components/ZapErrorMessage.tsx
var ZapErrorMessage = __webpack_require__(81135);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/components/ConfirmZapInModal.tsx
















var clamp = function(num, min, max) {
    return Math.min(Math.max(num, min), max);
};
var ConfirmZapInModal = function(param) {
    var title = param.title, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, attemptingTxn = param.attemptingTxn, hash = param.hash, pendingText = param.pendingText, price = param.price, currencies = param.currencies, zapSwapTokenField = param.zapSwapTokenField, zapSwapOutTokenField = param.zapSwapOutTokenField, allowedSlippage = param.allowedSlippage, parsedAmounts = param.parsedAmounts, liquidityErrorMessage = param.liquidityErrorMessage, onAdd = param.onAdd, poolTokenPercentage = param.poolTokenPercentage, liquidityMinted = param.liquidityMinted, pair = param.pair, zapInEstimated = param.zapInEstimated, rebalancing = param.rebalancing, zapMode = param.zapMode, toggleZapMode = param.toggleZapMode;
    var ref, ref1, ref2, ref3;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var totalPoolTokens = (0,useTotalSupply/* default */.Z)(pair.liquidityToken);
    var swapInCurrencyAmount = parsedAmounts[zapSwapTokenField];
    var swapOutCurrencyAmount = parsedAmounts[zapSwapOutTokenField];
    var ref4 = (0,useTooltip/* default */.Z)(swapInCurrencyAmount && !swapOutCurrencyAmount ? t("There is no %token1% input. Half of %token0% input is converted into %token1% to add liquidity.", {
        token0: (ref = currencies[zapSwapTokenField]) === null || ref === void 0 ? void 0 : ref.symbol,
        token1: (ref1 = currencies[zapSwapOutTokenField]) === null || ref1 === void 0 ? void 0 : ref1.symbol
    }) : t("There is not enough %token1% input to match 50/50. Some of %token0% will be converted to %token1%", {
        token0: (ref2 = currencies[zapSwapTokenField]) === null || ref2 === void 0 ? void 0 : ref2.symbol,
        token1: (ref3 = currencies[zapSwapOutTokenField]) === null || ref3 === void 0 ? void 0 : ref3.symbol
    }), {
        placement: "auto-start"
    }), targetRef = ref4.targetRef, tooltip = ref4.tooltip, tooltipVisible = ref4.tooltipVisible;
    var ref5 = (0,_sliced_to_array/* default */.Z)(!!pair && !!totalPoolTokens && !!liquidityMinted && // this condition is a short-circuit in the case where useTokenBalance updates sooner than useTotalSupply
    src/* JSBI.greaterThanOrEqual */.QA.greaterThanOrEqual(totalPoolTokens.quotient, liquidityMinted.quotient) ? [
        pair.getLiquidityValue(pair.token0, totalPoolTokens, liquidityMinted, false),
        pair.getLiquidityValue(pair.token1, totalPoolTokens, liquidityMinted, false), 
    ] : [
        undefined,
        undefined
    ], 2), token0Deposited = ref5[0], token1Deposited = ref5[1];
    var swapInTokenAmount = (0,react.useMemo)(function() {
        return zapInEstimated && src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount((0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[zapSwapTokenField], chainId), zapInEstimated.swapAmountIn.toString());
    }, [
        chainId,
        currencies,
        zapInEstimated,
        zapSwapTokenField
    ]);
    var swapOutTokenAmount = (0,react.useMemo)(function() {
        return (zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut) && src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount((0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[zapSwapOutTokenField], chainId), zapInEstimated.swapAmountOut.toString());
    }, [
        chainId,
        currencies,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut,
        zapSwapOutTokenField
    ]);
    var inputPercent = (0,react.useMemo)(function() {
        return swapInCurrencyAmount && swapOutCurrencyAmount ? clamp(// TODO: avoid use number
        +swapInCurrencyAmount.toExact() / +swapOutCurrencyAmount.toExact() / (+pair.priceOf(swapOutCurrencyAmount.currency.wrapped).toSignificant() + +swapInCurrencyAmount.toExact() / +swapOutCurrencyAmount.toExact()), 0.05, 0.95) : swapInCurrencyAmount && !swapOutCurrencyAmount ? 1 : undefined;
    }, [
        pair,
        swapInCurrencyAmount,
        swapOutCurrencyAmount
    ]);
    var tokenDeposited = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, zapSwapTokenField, (swapInTokenAmount === null || swapInTokenAmount === void 0 ? void 0 : swapInTokenAmount.currency) && (pair === null || pair === void 0 ? void 0 : pair.token0) ? pair.token0.equals(swapInTokenAmount.currency) ? token0Deposited : token1Deposited : undefined), (0,_define_property/* default */.Z)(_obj, zapSwapOutTokenField, (swapOutTokenAmount === null || swapOutTokenAmount === void 0 ? void 0 : swapOutTokenAmount.currency) && (pair === null || pair === void 0 ? void 0 : pair.token1) ? pair.token1.equals(swapOutTokenAmount.currency) ? token1Deposited : token0Deposited : undefined), _obj;
    }, [
        pair.token0,
        pair.token1,
        swapInTokenAmount === null || swapInTokenAmount === void 0 ? void 0 : swapInTokenAmount.currency,
        swapOutTokenAmount === null || swapOutTokenAmount === void 0 ? void 0 : swapOutTokenAmount.currency,
        token0Deposited,
        token1Deposited,
        zapSwapOutTokenField,
        zapSwapTokenField, 
    ]);
    var modalHeader = (0,react.useCallback)(function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddLiquidityModalHeader, {
            allowedSlippage: allowedSlippage,
            currencies: currencies,
            liquidityMinted: liquidityMinted,
            poolTokenPercentage: poolTokenPercentage,
            price: price,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PairDistribution, {
                    title: t("Input"),
                    percent: inputPercent,
                    currencyA: swapInCurrencyAmount ? currencies[zapSwapTokenField] : undefined,
                    currencyAValue: swapInCurrencyAmount === null || swapInCurrencyAmount === void 0 ? void 0 : swapInCurrencyAmount.toSignificant(6),
                    currencyB: swapOutCurrencyAmount ? currencies[zapSwapOutTokenField] : undefined,
                    currencyBValue: swapOutCurrencyAmount === null || swapOutCurrencyAmount === void 0 ? void 0 : swapOutCurrencyAmount.toSignificant(6)
                }),
                swapOutTokenAmount && swapInTokenAmount && currencies[zapSwapTokenField] && currencies[zapSwapOutTokenField] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    gap: "16px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                            color: "textSubtle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                            gap: "6px",
                            justify: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                    gap: "2px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: swapInTokenAmount === null || swapInTokenAmount === void 0 ? void 0 : swapInTokenAmount.toSignificant(6)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                            currency: currencies[zapSwapTokenField]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: currencies[zapSwapTokenField].symbol
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: t("to")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                    gap: "2px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: swapOutTokenAmount === null || swapOutTokenAmount === void 0 ? void 0 : swapOutTokenAmount.toSignificant(6)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                            currency: currencies[zapSwapOutTokenField]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: currencies[zapSwapOutTokenField].symbol
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                            color: "textSubtle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    gap: "4px",
                    children: [
                        tooltipVisible && tooltip,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PairDistribution, {
                            tooltipTargetRef: targetRef,
                            title: t("Pooled"),
                            percent: 0.5,
                            currencyA: currencies[zapSwapTokenField],
                            currencyAValue: tokenDeposited === null || tokenDeposited === void 0 ? void 0 : (ref = tokenDeposited[zapSwapTokenField]) === null || ref === void 0 ? void 0 : ref.toSignificant(6),
                            currencyB: currencies[zapSwapOutTokenField],
                            currencyBValue: tokenDeposited === null || tokenDeposited === void 0 ? void 0 : (ref1 = tokenDeposited[zapSwapOutTokenField]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)
                        })
                    ]
                })
            ]
        });
    }, [
        allowedSlippage,
        currencies,
        liquidityMinted,
        poolTokenPercentage,
        price,
        t,
        inputPercent,
        swapInCurrencyAmount,
        zapSwapTokenField,
        swapOutCurrencyAmount,
        zapSwapOutTokenField,
        swapOutTokenAmount,
        swapInTokenAmount,
        tooltip,
        tooltipVisible,
        targetRef,
        tokenDeposited, 
    ]);
    var modalBottom = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: "100%",
            onClick: onAdd,
            mt: "20px",
            children: t("Confirm Supply")
        });
    }, [
        onAdd,
        t
    ]);
    var confirmationContent = (0,react.useCallback)(function() {
        return liquidityErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapErrorMessage/* ZapErrorMessages */.p, {
                    isSingleToken: !rebalancing,
                    zapMode: zapMode,
                    toggleZapMode: toggleZapMode,
                    onModalDismiss: onDismiss
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
                    onDismiss: onDismiss,
                    message: liquidityErrorMessage
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* ConfirmationModalContent */.pM, {
            topContent: modalHeader,
            bottomContent: modalBottom
        });
    }, [
        liquidityErrorMessage,
        rebalancing,
        zapMode,
        toggleZapMode,
        onDismiss,
        modalHeader,
        modalBottom
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* default */.ZP, {
        minWidth: [
            "100%",
            ,
            "420px"
        ],
        title: title,
        onDismiss: onDismiss,
        customOnDismiss: customOnDismiss,
        attemptingTxn: attemptingTxn,
        currencyToAdd: pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
        hash: hash,
        content: confirmationContent,
        pendingText: pendingText
    });
};
/* harmony default export */ var components_ConfirmZapInModal = (ConfirmZapInModal);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardFooter.tsx
var CardFooter = __webpack_require__(5349);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDropDown.tsx
var ArrowDropDown = __webpack_require__(63822);
// EXTERNAL MODULE: ./src/components/SearchModal/CurrencySearchModal.tsx + 11 modules
var CurrencySearchModal = __webpack_require__(91548);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(2629);
;// CONCATENATED MODULE: ./src/components/CurrencySelect/index.tsx





function CurrencySelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n  box-shadow: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 16px;\n  background: ",
        ";\n  transition: border-radius 0.15s;\n"
    ]);
    CurrencySelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  position: relative;\n  background: ",
        ";\n  border-radius: 16px;\n  height: 40px;\n  min-width: 136px;\n  user-select: none;\n  z-index: 20;\n\n  ",
        " {\n    min-width: 168px;\n  }\n\n  .down-icon {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var DropDownHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8091529-0"
})(CurrencySelect_templateObject(), function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.input;
});
var DropDownContainer = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-8091529-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var CurrencySelect = function(_param) {
    var onCurrencySelect = _param.onCurrencySelect, selectedCurrency = _param.selectedCurrency, otherSelectedCurrency = _param.otherSelectedCurrency, showCommonBases = _param.showCommonBases, commonBasesType = _param.commonBasesType, hideBalance = _param.hideBalance, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCurrencySelect",
        "selectedCurrency",
        "otherSelectedCurrency",
        "showCommonBases",
        "commonBasesType",
        "hideBalance"
    ]);
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var selectedCurrencyBalance = (0,wallet_hooks/* useCurrencyBalance */._h)(account !== null && account !== void 0 ? account : undefined, !hideBalance && selectedCurrency ? selectedCurrency : undefined);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySearchModal/* default */.Z, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: selectedCurrency,
        otherSelectedCurrency: otherSelectedCurrency,
        showCommonBases: showCommonBases,
        commonBasesType: commonBasesType
    })), 1), onPresentCurrencyModal = ref[0];
    var price = (0,useBUSDPrice/* default */.ZP)(selectedCurrencyBalance && selectedCurrency ? selectedCurrency : undefined);
    var quoted = selectedCurrencyBalance && (price === null || price === void 0 ? void 0 : price.quote(selectedCurrencyBalance));
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownContainer, {
                p: 0,
                onClick: onPresentCurrencyModal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            id: "pair",
                            color: !selectedCurrency ? "text" : undefined,
                            children: !selectedCurrency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: t("Select")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                        currency: selectedCurrency,
                                        size: "24px",
                                        style: {
                                            marginRight: "8px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        id: "pair",
                                        bold: true,
                                        children: selectedCurrency && selectedCurrency.symbol && selectedCurrency.symbol.length > 20 ? "".concat(selectedCurrency.symbol.slice(0, 4), "...").concat(selectedCurrency.symbol.slice(selectedCurrency.symbol.length - 5, selectedCurrency.symbol.length)) : selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.symbol
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {
                        color: "text",
                        className: "down-icon"
                    })
                ]
            }),
            account && !!selectedCurrency && !hideBalance && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                        justify: "space-between",
                        gap: "2px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "12px",
                                children: [
                                    t("Balance"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                children: (ref1 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref1 !== void 0 ? ref1 : t("Loading")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                            Number.isFinite(+(quoted === null || quoted === void 0 ? void 0 : quoted.toExact())) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                children: [
                                    "~$",
                                    (0,formatBalance/* formatNumber */.uf)(+quoted.toExact())
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(44142);
// EXTERNAL MODULE: ./src/utils/formatInfoNumbers.ts
var formatInfoNumbers = __webpack_require__(59604);
// EXTERNAL MODULE: ./src/utils/currencyId.ts
var currencyId = __webpack_require__(29159);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/useCurrencySelectRoute.ts





var useCurrencySelectRoute = function() {
    var native = (0,useNativeCurrency/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(router.query.currency || [], 2), currencyIdA = ref[0], currencyIdB = ref[1];
    var handleCurrencyASelect = (0,react.useCallback)(function(currencyA_) {
        var newCurrencyIdA = (0,currencyId/* default */.Z)(currencyA_);
        if (newCurrencyIdA === currencyIdB) {
            router.replace("/add/".concat(currencyIdB, "/").concat(currencyIdA), undefined, {
                shallow: true
            });
        } else if (currencyIdB) {
            router.replace("/add/".concat(newCurrencyIdA, "/").concat(currencyIdB), undefined, {
                shallow: true
            });
        } else {
            router.replace("/add/".concat(newCurrencyIdA), undefined, {
                shallow: true
            });
        }
    }, [
        currencyIdB,
        router,
        currencyIdA
    ]);
    var handleCurrencyBSelect = (0,react.useCallback)(function(currencyB_) {
        var newCurrencyIdB = (0,currencyId/* default */.Z)(currencyB_);
        if (currencyIdA === newCurrencyIdB) {
            if (currencyIdB) {
                router.replace("/add/".concat(currencyIdB, "/").concat(newCurrencyIdB), undefined, {
                    shallow: true
                });
            } else {
                router.replace("/add/".concat(newCurrencyIdB), undefined, {
                    shallow: true
                });
            }
        } else {
            router.replace("/add/".concat(currencyIdA || native.symbol, "/").concat(newCurrencyIdB), undefined, {
                shallow: true
            });
        }
    }, [
        currencyIdA,
        router,
        currencyIdB,
        native
    ]);
    return {
        handleCurrencyASelect: handleCurrencyASelect,
        handleCurrencyBSelect: handleCurrencyBSelect
    };
};

// EXTERNAL MODULE: ./src/components/SearchModal/types.ts
var SearchModal_types = __webpack_require__(93156);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/ChoosePair.tsx















function ChoosePair(param) {
    var currencyA = param.currencyA, currencyB = param.currencyB, error = param.error, onNext = param.onNext;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var isValid = !error;
    var ref = useCurrencySelectRoute(), handleCurrencyASelect = ref.handleCurrencyASelect, handleCurrencyBSelect = ref.handleCurrencyBSelect;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,usePairs/* usePair */.yX)(currencyA, currencyB), 2), pair = ref1[1];
    var poolData = (0,hooks/* useLPApr */.aT)(pair);
    var ref2 = (0,useTooltip/* default */.Z)(t("Based on last 7 days' performance. Does not account for impermanent loss"), {
        placement: "bottom"
    }), targetRef = ref2.targetRef, tooltip = ref2.tooltip, tooltipVisible = ref2.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppHeader */.t, {
                title: t("Add Liquidity"),
                subtitle: t("Receive LP tokens and earn 0.20% trading fees"),
                helper: t("Liquidity providers earn a 0.20% trading fee on all trades made for that token pair, proportional to their share of the liquidity pool."),
                backTo: "/liquidity"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textTransform: "uppercase",
                            color: "secondary",
                            bold: true,
                            small: true,
                            pb: "24px",
                            children: t("Choose a valid pair")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* FlexGap */.O, {
                            gap: "4px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelect, {
                                    id: "add-liquidity-select-tokena",
                                    selectedCurrency: currencyA,
                                    onCurrencySelect: handleCurrencyASelect,
                                    showCommonBases: true,
                                    commonBasesType: SearchModal_types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    color: "textSubtle"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelect, {
                                    id: "add-liquidity-select-tokenb",
                                    selectedCurrency: currencyB,
                                    onCurrencySelect: handleCurrencyBSelect,
                                    showCommonBases: true,
                                    commonBasesType: SearchModal_types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                })
                            ]
                        }),
                        pair && poolData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                            mt: "24px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                    ref: targetRef,
                                    bold: true,
                                    fontSize: "12px",
                                    color: "secondary",
                                    children: t("LP reward APR")
                                }),
                                tooltipVisible && tooltip,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    color: "primary",
                                    children: [
                                        (0,formatInfoNumbers/* formatAmount */.d)(poolData.lpApr7d),
                                        "%"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardFooter/* default */.Z, {
                children: !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                    width: "100%"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    "data-test": "choose-pair-next",
                    width: "100%",
                    variant: !isValid ? "danger" : "primary",
                    onClick: onNext,
                    disabled: !isValid,
                    children: error !== null && error !== void 0 ? error : t("Add Liquidity")
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/ZapCheckbox.tsx
var ZapCheckbox = __webpack_require__(25099);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/index.tsx




























































var Steps;
(function(Steps) {
    Steps[Steps["Choose"] = 0] = "Choose";
    Steps[Steps["Add"] = 1] = "Add";
})(Steps || (Steps = {}));
var zapAddress = (0,addressHelpers/* getZapAddress */._M)();
function AddLiquidity() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
    var router = (0,next_router.useRouter)();
    var ref30 = (0,useActiveWeb3React/* default */.Z)(), account = ref30.account, chainId = ref30.chainId, isWrongNetwork = ref30.isWrongNetwork;
    var addPair = (0,user_hooks/* usePairAdder */.uB)();
    var ref31 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useZapModeManager */.$f)(), 1), zapMode = ref31[0];
    var expertMode = (0,user_hooks/* useIsExpertMode */.LO)();
    var native = (0,useNativeCurrency/* default */.Z)();
    var ref32 = (0,react.useState)(true), temporarilyZapMode = ref32[0], setTemporarilyZapMode = ref32[1];
    var ref33;
    var ref34 = (0,_sliced_to_array/* default */.Z)(router.query.currency || [
        native.symbol,
        (ref33 = (ref = tokens_src/* CAKE */.cr[chainId]) === null || ref === void 0 ? void 0 : ref.address) !== null && ref33 !== void 0 ? ref33 : (ref1 = tokens_src/* USDC */.gn[chainId]) === null || ref1 === void 0 ? void 0 : ref1.address, 
    ], 2), currencyIdA = ref34[0], currencyIdB = ref34[1];
    var ref35 = (0,react.useState)(Steps.Choose), steps = ref35[0], setSteps = ref35[1];
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var currencyA = (0,Tokens/* useCurrency */.U8)(currencyIdA);
    var currencyB = (0,Tokens/* useCurrency */.U8)(currencyIdB);
    (0,react.useEffect)(function() {
        if (!currencyIdA && !currencyIdB) {
            dispatch((0,actions/* resetMintState */.dA)());
        }
    }, [
        dispatch,
        currencyIdA,
        currencyIdB
    ]);
    (0,react.useEffect)(function() {
        if (router.query.step === "1") {
            setSteps(Steps.Add);
        }
    }, [
        router.query
    ]);
    var zapModeStatus = (0,react.useMemo)(function() {
        return !!zapMode && temporarilyZapMode;
    }, [
        zapMode,
        temporarilyZapMode
    ]);
    // mint state
    var ref36 = useMintState(), independentField = ref36.independentField, typedValue = ref36.typedValue, otherTypedValue = ref36.otherTypedValue;
    var ref37 = useDerivedMintInfo(currencyA !== null && currencyA !== void 0 ? currencyA : undefined, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), dependentField = ref37.dependentField, currencies = ref37.currencies, pair = ref37.pair, pairState = ref37.pairState, currencyBalances = ref37.currencyBalances, mintParsedAmounts = ref37.parsedAmounts, price = ref37.price, noLiquidity = ref37.noLiquidity, liquidityMinted = ref37.liquidityMinted, poolTokenPercentage = ref37.poolTokenPercentage, error = ref37.error, addError = ref37.addError;
    var poolData = (0,hooks/* useLPApr */.aT)(pair);
    var ref38 = (0,useTooltip/* default */.Z)(t("Based on last 7 days' performance. Does not account for impermanent loss"), {
        placement: "bottom"
    }), targetRef = ref38.targetRef, tooltip = ref38.tooltip, tooltipVisible = ref38.tooltipVisible;
    var ref39 = useMintActionHandlers(noLiquidity), onFieldAInput = ref39.onFieldAInput, onFieldBInput = ref39.onFieldBInput;
    // modal and loading
    var ref40 = (0,react.useState)({
        attemptingTxn: false,
        liquidityErrorMessage: undefined,
        txHash: undefined
    }), ref41 = ref40[0], attemptingTxn = ref41.attemptingTxn, liquidityErrorMessage = ref41.liquidityErrorMessage, txHash = ref41.txHash, setLiquidityState = ref40[1];
    // Zap state
    var ref42 = (0,react.useState)(true), zapTokenToggleA = ref42[0], setZapTokenToggleA = ref42[1];
    var ref43 = (0,react.useState)(true), zapTokenToggleB = ref43[0], setZapTokenToggleB = ref43[1];
    var zapTokenCheckedA = zapTokenToggleA && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref2 = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.greaterThan(0));
    var zapTokenCheckedB = zapTokenToggleB && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref3 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.greaterThan(0));
    // txn values
    var deadline = (0,useTransactionDeadline/* default */.Z)() // custom from users settings
    ;
    var ref44 // custom from users
     = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref44[0];
    // get the max amounts user can add
    var maxAmounts = [
        actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
        actions/* Field.CURRENCY_B */.gN.CURRENCY_B
    ].reduce(function(accumulator, field) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulator), (0,_define_property/* default */.Z)({}, field, (0,maxAmountSpend/* maxAmountSpend */.i)(currencyBalances[field])));
    }, {});
    var canZap = (0,react.useMemo)(function() {
        return !!zapModeStatus && !noLiquidity && supportChains/* SUPPORT_ZAP.includes */.K.includes(chainId) && !(pair && src/* JSBI.lessThan */.QA.lessThan(pair.reserve0.quotient, src/* MINIMUM_LIQUIDITY */.Xh) || pair && src/* JSBI.lessThan */.QA.lessThan(pair.reserve1.quotient, src/* MINIMUM_LIQUIDITY */.Xh));
    }, [
        chainId,
        noLiquidity,
        pair,
        zapModeStatus
    ]);
    var ref45 = useCurrencySelectRoute(), handleCurrencyASelect = ref45.handleCurrencyASelect, handleCurrencyBSelect = ref45.handleCurrencyBSelect;
    var _ref = useZapIn({
        pair: pair,
        canZap: canZap,
        currencyA: currencyA,
        currencyB: currencyB,
        currencyBalances: currencyBalances,
        zapTokenCheckedA: zapTokenCheckedA,
        zapTokenCheckedB: zapTokenCheckedB,
        maxAmounts: maxAmounts
    }), zapInEstimating = _ref.zapInEstimating, rebalancing = _ref.rebalancing, zapIn = (0,_object_without_properties/* default */.Z)(_ref, [
        "zapInEstimating",
        "rebalancing"
    ]);
    var parsedAmounts = canZap ? zapIn.parsedAmounts : mintParsedAmounts;
    var preferZapInstead = canZap && !zapIn.noNeedZap;
    var ref46;
    // get formatted amounts
    var formattedAmounts = (0,react.useMemo)(function() {
        var ref;
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, independentField, canZap && (independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A && !zapTokenCheckedA || independentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B && !zapTokenCheckedB) ? "" : typedValue), (0,_define_property/* default */.Z)(_obj, dependentField, noLiquidity ? otherTypedValue : (ref46 = (ref = parsedAmounts[dependentField]) === null || ref === void 0 ? void 0 : ref.toSignificant(6)) !== null && ref46 !== void 0 ? ref46 : ""), _obj;
    }, [
        canZap,
        dependentField,
        independentField,
        noLiquidity,
        otherTypedValue,
        parsedAmounts,
        typedValue,
        zapTokenCheckedA,
        zapTokenCheckedB, 
    ]);
    var atMaxAmounts = [
        actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
        actions/* Field.CURRENCY_B */.gN.CURRENCY_B
    ].reduce(function(accumulator, field) {
        var ref;
        var _field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulator), (0,_define_property/* default */.Z)({}, field, (ref = maxAmounts[field]) === null || ref === void 0 ? void 0 : ref.equalTo((_field = parsedAmounts[field]) !== null && _field !== void 0 ? _field : "0")));
    }, {});
    // check whether the user has approved the router on the tokens
    var ref47 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.qL)(parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], preferZapInstead ? zapAddress : exchange/* ROUTER_ADDRESS */.bR[chainId]), 2), approvalA = ref47[0], approveACallback = ref47[1];
    var ref48 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.qL)(parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], preferZapInstead ? zapAddress : exchange/* ROUTER_ADDRESS */.bR[chainId]), 2), approvalB = ref48[0], approveBCallback = ref48[1];
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var routerContract = (0,utils_exchange/* useRouterContract */.Ti)();
    function onAdd() {
        return _onAdd.apply(this, arguments);
    }
    function _onAdd() {
        _onAdd = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var parsedAmountA, parsedAmountB, _obj, amountsMin, estimate, method, args, value, ref, ref1, tokenBIsNative, ref2, ref3, ref4, ref5, ref6;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!chainId || !account || !routerContract)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        parsedAmountA = mintParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], parsedAmountB = mintParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
                        if (!(!parsedAmountA || !parsedAmountB || !currencyA || !currencyB || !deadline)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        ;
                        amountsMin = (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, (0,utils_exchange/* calculateSlippageAmount */.uc)(parsedAmountA, noLiquidity ? 0 : allowedSlippage)[0]), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, (0,utils_exchange/* calculateSlippageAmount */.uc)(parsedAmountB, noLiquidity ? 0 : allowedSlippage)[0]), _obj);
                        ;
                        ;
                        ;
                        ;
                        if ((currencyA === null || currencyA === void 0 ? void 0 : currencyA.isNative) || (currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative)) {
                            ;
                            tokenBIsNative = currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative;
                            estimate = routerContract.estimateGas.addLiquidityETH;
                            method = routerContract.addLiquidityETH;
                            ;
                            args = [
                                (ref2 = (ref = tokenBIsNative ? currencyA : currencyB) === null || ref === void 0 ? void 0 : (ref1 = ref.wrapped) === null || ref1 === void 0 ? void 0 : ref1.address) !== null && ref2 !== void 0 ? ref2 : "",
                                (tokenBIsNative ? parsedAmountA : parsedAmountB).quotient.toString(),
                                amountsMin[tokenBIsNative ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B].toString(),
                                amountsMin[tokenBIsNative ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A].toString(),
                                account,
                                deadline.toHexString(), 
                            ];
                            value = bignumber/* BigNumber.from */.O$.from((tokenBIsNative ? parsedAmountB : parsedAmountA).quotient.toString());
                        } else {
                            ;
                            estimate = routerContract.estimateGas.addLiquidity;
                            method = routerContract.addLiquidity;
                            ;
                            args = [
                                (ref5 = currencyA === null || currencyA === void 0 ? void 0 : (ref3 = currencyA.wrapped) === null || ref3 === void 0 ? void 0 : ref3.address) !== null && ref5 !== void 0 ? ref5 : "",
                                (ref6 = currencyB === null || currencyB === void 0 ? void 0 : (ref4 = currencyB.wrapped) === null || ref4 === void 0 ? void 0 : ref4.address) !== null && ref6 !== void 0 ? ref6 : "",
                                parsedAmountA.quotient.toString(),
                                parsedAmountB.quotient.toString(),
                                amountsMin[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].toString(),
                                amountsMin[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].toString(),
                                account,
                                deadline.toHexString(), 
                            ];
                            value = null;
                        }
                        setLiquidityState({
                            attemptingTxn: true,
                            liquidityErrorMessage: undefined,
                            txHash: undefined
                        });
                        _ctx.next = 15;
                        return estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                            value ? {
                                value: value
                            } : {}
                        ])).then(function(estimatedGasLimit) {
                            return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value ? {
                                    value: value
                                } : {}), {
                                    gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                    gasPrice: gasPrice
                                })
                            ])).then(function(response) {
                                var ref, ref1, ref2, ref3;
                                setLiquidityState({
                                    attemptingTxn: false,
                                    liquidityErrorMessage: undefined,
                                    txHash: response.hash
                                });
                                var symbolA = (ref = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.symbol;
                                var amountA = (ref1 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(3);
                                var symbolB = (ref2 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.symbol;
                                var amountB = (ref3 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.toSignificant(3);
                                addTransaction(response, {
                                    summary: "Add ".concat(amountA, " ").concat(symbolA, " and ").concat(amountB, " ").concat(symbolB),
                                    translatableSummary: {
                                        text: "Add %amountA% %symbolA% and %amountB% %symbolB%",
                                        data: {
                                            amountA: amountA,
                                            symbolA: symbolA,
                                            amountB: amountB,
                                            symbolB: symbolB
                                        }
                                    },
                                    type: "add-liquidity"
                                });
                                if (pair) {
                                    addPair(pair);
                                }
                            });
                        }).catch(function(err) {
                            if (err && err.code !== 4001) {
                                (0,sentry/* logError */.H)(err);
                                console.error("Add Liquidity failed", err, args, value);
                            }
                            setLiquidityState({
                                attemptingTxn: false,
                                liquidityErrorMessage: err && err.code !== 4001 ? t("Add liquidity failed: %message%", {
                                    message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                }) : undefined,
                                txHash: undefined
                            });
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _onAdd.apply(this, arguments);
    }
    var ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56;
    var pendingText = preferZapInstead ? t("Zapping %amountA% %symbolA% and %amountB% %symbolB%", {
        amountA: (ref49 = (ref4 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref4 === void 0 ? void 0 : ref4.toSignificant(6)) !== null && ref49 !== void 0 ? ref49 : "0",
        symbolA: (ref50 = (ref5 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref5 === void 0 ? void 0 : ref5.symbol) !== null && ref50 !== void 0 ? ref50 : "",
        amountB: (ref51 = (ref6 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref6 === void 0 ? void 0 : ref6.toSignificant(6)) !== null && ref51 !== void 0 ? ref51 : "0",
        symbolB: (ref52 = (ref7 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref7 === void 0 ? void 0 : ref7.symbol) !== null && ref52 !== void 0 ? ref52 : ""
    }) : t("Supplying %amountA% %symbolA% and %amountB% %symbolB%", {
        amountA: (ref53 = (ref8 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref8 === void 0 ? void 0 : ref8.toSignificant(6)) !== null && ref53 !== void 0 ? ref53 : "",
        symbolA: (ref54 = (ref9 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref9 === void 0 ? void 0 : ref9.symbol) !== null && ref54 !== void 0 ? ref54 : "",
        amountB: (ref55 = (ref10 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref10 === void 0 ? void 0 : ref10.toSignificant(6)) !== null && ref55 !== void 0 ? ref55 : "",
        symbolB: (ref56 = (ref11 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref11 === void 0 ? void 0 : ref11.symbol) !== null && ref56 !== void 0 ? ref56 : ""
    });
    var handleDismissConfirmation = (0,react.useCallback)(function() {
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onFieldAInput("");
        }
    }, [
        onFieldAInput,
        txHash
    ]);
    var addIsUnsupported = (0,Trades/* useIsTransactionUnsupported */.mP)(currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_A, currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_B);
    var addIsWarning = (0,Trades/* useIsTransactionWarning */.uK)(currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_A, currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_B);
    var zapContract = (0,useContract/* useZapContract */.n9)(true);
    var ref57 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmAddLiquidityModal, {
        title: noLiquidity ? t("You are creating a pool") : t("You will receive"),
        customOnDismiss: handleDismissConfirmation,
        attemptingTxn: attemptingTxn,
        hash: txHash,
        pendingText: pendingText,
        currencyToAdd: pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
        allowedSlippage: allowedSlippage,
        onAdd: onAdd,
        parsedAmounts: parsedAmounts,
        currencies: currencies,
        liquidityErrorMessage: liquidityErrorMessage,
        price: price,
        noLiquidity: noLiquidity,
        poolTokenPercentage: poolTokenPercentage,
        liquidityMinted: liquidityMinted
    }), true, true, "addLiquidityModal"), 1), onPresentAddLiquidityModal = ref57[0];
    function onZapIn() {
        return _onZapIn.apply(this, arguments);
    }
    function _onZapIn() {
        _onZapIn = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, method, args, value, summary, translatableSummary, minAmountOut, ref1, ref2, ref3, ref4, maxAmountIn, amountA, symbolA, amountB, symbolB, tokenBIsBNB, ref5, amount, symbol, ref6, amount1, symbol1, lpSymbol;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!canZap || !parsedAmounts || !zapIn.zapInEstimated || !chainId || !zapContract)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        ;
                        ;
                        ;
                        ;
                        ;
                        minAmountOut = zapIn.zapInEstimated.swapAmountOut.mul(10000 - allowedSlippage).div(10000);
                        if (rebalancing) {
                            ;
                            maxAmountIn = zapIn.zapInEstimated.swapAmountIn.mul(10000 + allowedSlippage).div(10000);
                            amountA = (ref1 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(3);
                            symbolA = (ref2 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.symbol;
                            amountB = (ref3 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.toSignificant(3);
                            symbolB = (ref4 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref4 === void 0 ? void 0 : ref4.symbol;
                            summary = "Zap ".concat(amountA, " ").concat(symbolA, " and ").concat(amountB, " ").concat(symbolB);
                            translatableSummary = {
                                text: "Zap %amountA% %symbolA% and %amountB% %symbolB%",
                                data: {
                                    amountA: amountA,
                                    symbolA: symbolA,
                                    amountB: amountB,
                                    symbolB: symbolB
                                }
                            };
                            if ((currencyA === null || currencyA === void 0 ? void 0 : currencyA.isNative) || (currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative)) {
                                tokenBIsBNB = currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative;
                                method = "zapInBNBRebalancing";
                                args = [
                                    (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[tokenBIsBNB ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B], chainId).address,
                                    parsedAmounts[tokenBIsBNB ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B].quotient.toString(),
                                    pair.liquidityToken.address,
                                    maxAmountIn,
                                    minAmountOut,
                                    zapIn.zapInEstimated.isToken0Sold && !tokenBIsBNB
                                ];
                                value = parsedAmounts[tokenBIsBNB ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A].quotient.toString();
                            } else {
                                method = "zapInTokenRebalancing";
                                args = [
                                    (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], chainId).address,
                                    (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], chainId).address,
                                    parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].quotient.toString(),
                                    parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].quotient.toString(),
                                    pair.liquidityToken.address,
                                    maxAmountIn,
                                    minAmountOut,
                                    zapIn.zapInEstimated.isToken0Sold
                                ];
                            }
                        } else if ((ref = currencies[zapIn.swapTokenField]) === null || ref === void 0 ? void 0 : ref.isNative) {
                            ;
                            method = "zapInBNB";
                            args = [
                                pair.liquidityToken.address,
                                minAmountOut
                            ];
                            amount = (ref5 = parsedAmounts[zapIn.swapTokenField]) === null || ref5 === void 0 ? void 0 : ref5.toSignificant(3);
                            symbol = (0,getLpSymbol/* getLPSymbol */.z)(pair.token0.symbol, pair.token1.symbol);
                            summary = "Zap in ".concat(amount, " BNB for ").concat(symbol);
                            translatableSummary = {
                                text: "Zap in %amount% BNB for %symbol%",
                                data: {
                                    amount: amount,
                                    symbol: symbol
                                }
                            };
                            value = parsedAmounts[zapIn.swapTokenField].quotient.toString();
                        } else {
                            ;
                            method = "zapInToken";
                            args = [
                                (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[zapIn.swapTokenField], chainId).address,
                                parsedAmounts[zapIn.swapTokenField].quotient.toString(),
                                pair.liquidityToken.address,
                                minAmountOut, 
                            ];
                            amount1 = (ref6 = parsedAmounts[zapIn.swapTokenField]) === null || ref6 === void 0 ? void 0 : ref6.toSignificant(3);
                            symbol1 = currencies[zapIn.swapTokenField].symbol;
                            lpSymbol = (0,getLpSymbol/* getLPSymbol */.z)(pair.token0.symbol, pair.token1.symbol);
                            summary = "Zap in ".concat(amount1, " ").concat(symbol1, " for ").concat(lpSymbol);
                            translatableSummary = {
                                text: "Zap in %amount% %symbol% for %lpSymbol%",
                                data: {
                                    amount: amount1,
                                    symbol: symbol1,
                                    lpSymbol: lpSymbol
                                }
                            };
                        }
                        setLiquidityState({
                            attemptingTxn: true,
                            liquidityErrorMessage: undefined,
                            txHash: undefined
                        });
                        (0,calls/* callWithEstimateGas */.Zj)(zapContract, method, args, value ? {
                            value: value,
                            gasPrice: gasPrice
                        } : {
                            gasPrice: gasPrice
                        }).then(function(response) {
                            setLiquidityState({
                                attemptingTxn: false,
                                liquidityErrorMessage: undefined,
                                txHash: response.hash
                            });
                            addTransaction(response, {
                                summary: summary,
                                translatableSummary: translatableSummary,
                                type: "add-liquidity"
                            });
                            if (pair) {
                                addPair(pair);
                            }
                        }).catch(function(err) {
                            if (err && err.code !== 4001) {
                                (0,sentry/* logError */.H)(err);
                                console.error("Add Liquidity failed", err, args, value);
                            }
                            setLiquidityState({
                                attemptingTxn: false,
                                liquidityErrorMessage: err && err.code !== 4001 ? t("Add liquidity failed: %message%", {
                                    message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                }) : undefined,
                                txHash: undefined
                            });
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _onZapIn.apply(this, arguments);
    }
    var ref58 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmZapInModal, {
        title: t("You will receive"),
        customOnDismiss: handleDismissConfirmation,
        attemptingTxn: attemptingTxn,
        hash: txHash,
        pendingText: pendingText,
        pair: pair,
        allowedSlippage: allowedSlippage,
        onAdd: onZapIn,
        parsedAmounts: parsedAmounts,
        currencies: currencies,
        liquidityErrorMessage: liquidityErrorMessage,
        price: price,
        poolTokenPercentage: zapIn.poolTokenPercentage,
        liquidityMinted: zapIn.liquidityMinted,
        zapSwapTokenField: zapIn.swapTokenField,
        zapSwapOutTokenField: zapIn.swapOutTokenField,
        zapInEstimated: zapIn.zapInEstimated,
        rebalancing: rebalancing,
        zapMode: zapModeStatus,
        toggleZapMode: setTemporarilyZapMode
    }), true, true, "zapInModal"), 1), onPresentZapInModal = ref58[0];
    var handleEnableZap = function() {
        if (!zapMode) {
            setTemporarilyZapMode(!zapMode);
        }
    };
    var isValid = !error;
    var errorText = error;
    if (preferZapInstead) {
        isValid = !error && !zapIn.error;
        errorText = error !== null && error !== void 0 ? error : zapIn.error;
    } else {
        isValid = !error && !addError;
        errorText = error !== null && error !== void 0 ? error : addError;
    }
    var buttonDisabled = !isValid || (zapIn.parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] || !preferZapInstead && zapTokenCheckedA) && approvalA !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED || (zapIn.parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] || !preferZapInstead && zapTokenCheckedB) && approvalB !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED || zapIn.priceSeverity > 3 && preferZapInstead;
    var showFieldAApproval = (zapTokenCheckedA || !preferZapInstead) && (approvalA === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING);
    var showFieldBApproval = (zapTokenCheckedB || !preferZapInstead) && (approvalB === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING);
    var shouldShowApprovalGroup = (showFieldAApproval || showFieldBApproval) && isValid;
    var oneCurrencyIsWNATIVE = Boolean(chainId && (currencyA && currencyA.equals(src/* WNATIVE */.FX[chainId]) || currencyB && currencyB.equals(src/* WNATIVE */.FX[chainId])));
    var noAnyInputAmount = !parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && !parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
    var showAddLiquidity = !!currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && !!currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] && steps === Steps.Add || !canZap;
    var showZapWarning = preferZapInstead && !noAnyInputAmount && (!rebalancing && !(!zapTokenCheckedA && !zapTokenCheckedB) || rebalancing && zapIn.priceSeverity > 3);
    var showReduceZapTokenButton = preferZapInstead && (zapIn.priceSeverity > 3 || zapIn.zapInEstimatedError) && maxAmounts[zapIn.swapTokenField];
    var showRebalancingConvert = !showZapWarning && !noAnyInputAmount && !showReduceZapTokenButton && preferZapInstead && zapIn.isDependentAmountGreaterThanMaxAmount && rebalancing;
    var showZapIsAvailable = !zapMode && !showZapWarning && !noAnyInputAmount && (!zapTokenCheckedA || !zapTokenCheckedB) && !noLiquidity && !(pair && src/* JSBI.lessThan */.QA.lessThan(pair.reserve0.quotient, src/* MINIMUM_LIQUIDITY */.Xh) || pair && src/* JSBI.lessThan */.QA.lessThan(pair.reserve1.quotient, src/* MINIMUM_LIQUIDITY */.Xh));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(App/* AppBody */.j, {
                children: [
                    !showAddLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoosePair, {
                        error: error,
                        currencyA: currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                        currencyB: currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                        onNext: function() {
                            return setSteps(Steps.Add);
                        }
                    }),
                    showAddLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppHeader */.t, {
                                title: ((ref12 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref12 === void 0 ? void 0 : ref12.symbol) && ((ref13 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref13 === void 0 ? void 0 : ref13.symbol) ? "".concat((0,getLpSymbol/* getLPSymbol */.z)(currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].symbol, currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].symbol)) : t("Add Liquidity"),
                                subtitle: t("Receive LP tokens and earn 0.20% trading fees"),
                                helper: t("Liquidity providers earn a 0.20% trading fee on all trades made for that token pair, proportional to their share of the liquidity pool."),
                                backTo: canZap ? function() {
                                    return setSteps(Steps.Choose);
                                } : "/liquidity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                    gap: "20px",
                                    children: [
                                        noLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* ColumnCenter */.lg, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                                variant: "warning",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            bold: true,
                                                            mb: "8px",
                                                            children: t("You are the first liquidity provider.")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            mb: "8px",
                                                            children: t("The ratio of tokens you add will set the price of this pool.")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            children: t("Once you are happy with the rate click supply to review.")
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                            disableCurrencySelect: canZap,
                                            showBUSD: true,
                                            onInputBlur: zapIn.onInputBlurOnce,
                                            error: zapIn.priceSeverity > 3 && zapIn.swapTokenField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
                                            disabled: canZap && !zapTokenCheckedA,
                                            beforeButton: canZap && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapCheckbox/* ZapCheckbox */.y, {
                                                disabled: currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref14 = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref14 === void 0 ? void 0 : ref14.equalTo(0),
                                                checked: zapTokenCheckedA,
                                                onChange: function(e) {
                                                    setZapTokenToggleA(e.target.checked);
                                                }
                                            }),
                                            onCurrencySelect: handleCurrencyASelect,
                                            zapStyle: canZap ? "zap" : "noZap",
                                            value: formattedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                            onUserInput: onFieldAInput,
                                            onMax: function() {
                                                var ref;
                                                var ref1;
                                                onFieldAInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                            },
                                            showMaxButton: !atMaxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                            currency: currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                            id: "add-liquidity-input-tokena",
                                            showCommonBases: true,
                                            commonBasesType: SearchModal_types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* ColumnCenter */.lg, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                                width: "16px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                            showBUSD: true,
                                            onInputBlur: zapIn.onInputBlurOnce,
                                            disabled: canZap && !zapTokenCheckedB,
                                            error: zapIn.priceSeverity > 3 && zapIn.swapTokenField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B,
                                            beforeButton: canZap && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapCheckbox/* ZapCheckbox */.y, {
                                                disabled: currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref15 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref15 === void 0 ? void 0 : ref15.equalTo(0),
                                                checked: zapTokenCheckedB,
                                                onChange: function(e) {
                                                    setZapTokenToggleB(e.target.checked);
                                                }
                                            }),
                                            onCurrencySelect: handleCurrencyBSelect,
                                            disableCurrencySelect: canZap,
                                            zapStyle: canZap ? "zap" : "noZap",
                                            value: formattedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                            onUserInput: onFieldBInput,
                                            onMax: function() {
                                                var ref;
                                                var ref1;
                                                onFieldBInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                            },
                                            showMaxButton: !atMaxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                            currency: currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                            id: "add-liquidity-input-tokenb",
                                            showCommonBases: true,
                                            commonBasesType: SearchModal_types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                        }),
                                        showZapWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: zapIn.priceSeverity > 3 ? "danger" : "warning",
                                            children: zapIn.priceSeverity > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                children: [
                                                    t("Price Impact Too High."),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: t("Reduce amount of %token% to maximum limit", {
                                                            token: (ref16 = currencies[zapIn.swapTokenField]) === null || ref16 === void 0 ? void 0 : ref16.symbol
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: t("No %token% input.", {
                                                            token: (ref17 = currencies[zapIn.swapOutTokenField]) === null || ref17 === void 0 ? void 0 : ref17.symbol
                                                        })
                                                    }),
                                                    " ",
                                                    t("Some of your %token0% will be converted to %token1%.", {
                                                        token0: (ref18 = currencies[zapIn.swapTokenField]) === null || ref18 === void 0 ? void 0 : ref18.symbol,
                                                        token1: (ref19 = currencies[zapIn.swapOutTokenField]) === null || ref19 === void 0 ? void 0 : ref19.symbol
                                                    })
                                                ]
                                            })
                                        }),
                                        showReduceZapTokenButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                                            style: {
                                                margin: "auto"
                                            },
                                            onClick: function() {
                                                return zapIn.convertToMaxZappable();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "secondary",
                                                scale: "sm",
                                                children: t("Reduce %token%", {
                                                    token: (ref20 = currencies[zapIn.swapTokenField]) === null || ref20 === void 0 ? void 0 : ref20.symbol
                                                })
                                            })
                                        }),
                                        showZapIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: "warning",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                children: [
                                                    t("Zap allows you to add liquidity with only 1 single token. Click"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        p: "0 4px",
                                                        scale: "sm",
                                                        variant: "text",
                                                        height: "auto",
                                                        onClick: handleEnableZap,
                                                        children: t("here")
                                                    }),
                                                    t("to try.")
                                                ]
                                            })
                                        }),
                                        showRebalancingConvert && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: "warning",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: t("Not enough %token%.", {
                                                                token: (ref21 = currencies[zapIn.swapOutTokenField]) === null || ref21 === void 0 ? void 0 : ref21.symbol
                                                            })
                                                        }),
                                                        " ",
                                                        zapIn.gasOverhead ? t("Some of your %token0% will be converted to %token1% before adding liquidity, but this may cause higher gas fees.", {
                                                            token0: (ref22 = currencies[zapIn.swapTokenField]) === null || ref22 === void 0 ? void 0 : ref22.symbol,
                                                            token1: (ref23 = currencies[zapIn.swapOutTokenField]) === null || ref23 === void 0 ? void 0 : ref23.symbol
                                                        }) : t("Some of your %token0% will be converted to %token1%.", {
                                                            token0: (ref24 = currencies[zapIn.swapTokenField]) === null || ref24 === void 0 ? void 0 : ref24.symbol,
                                                            token1: (ref25 = currencies[zapIn.swapOutTokenField]) === null || ref25 === void 0 ? void 0 : ref25.symbol
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        showRebalancingConvert && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                                            style: {
                                                margin: "auto"
                                            },
                                            onClick: function() {
                                                if (dependentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A) {
                                                    var ref;
                                                    var ref1;
                                                    onFieldAInput((ref1 = (ref = maxAmounts[dependentField]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                                } else {
                                                    var ref2;
                                                    var ref3;
                                                    onFieldBInput((ref3 = (ref2 = maxAmounts[dependentField]) === null || ref2 === void 0 ? void 0 : ref2.toExact()) !== null && ref3 !== void 0 ? ref3 : "");
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "secondary",
                                                scale: "sm",
                                                children: t("Don’t convert")
                                            })
                                        }),
                                        currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] && pairState !== usePairs/* PairState.INVALID */._G.INVALID && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* LightCard */.hl, {
                                                padding: "0px",
                                                borderRadius: "20px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                                                        padding: "1rem",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontSize: "14px",
                                                            children: noLiquidity ? t("Initial prices and pool share") : t("Prices and pool share")
                                                        })
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* LightCard */.hl, {
                                                        padding: "1rem",
                                                        borderRadius: "20px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddLiquidity_PoolPriceBar, {
                                                            currencies: currencies,
                                                            poolTokenPercentage: preferZapInstead ? zapIn.poolTokenPercentage : poolTokenPercentage,
                                                            noLiquidity: noLiquidity,
                                                            price: price
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    bold: true,
                                                    fontSize: "12px",
                                                    color: "secondary",
                                                    children: t("Slippage Tolerance")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    bold: true,
                                                    color: "primary",
                                                    children: [
                                                        allowedSlippage / 100,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }),
                                        pair && poolData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                                    ref: targetRef,
                                                    bold: true,
                                                    fontSize: "12px",
                                                    color: "secondary",
                                                    children: t("LP reward APR")
                                                }),
                                                tooltipVisible && tooltip,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    bold: true,
                                                    color: "primary",
                                                    children: [
                                                        (0,formatInfoNumbers/* formatAmount */.d)(poolData.lpApr7d),
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }),
                                        addIsUnsupported || addIsWarning ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            disabled: true,
                                            mb: "4px",
                                            children: t("Unsupported Asset")
                                        }) : !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {}) : isWrongNetwork ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                            gap: "md",
                                            children: [
                                                shouldShowApprovalGroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                    style: {
                                                        gap: "8px"
                                                    },
                                                    children: [
                                                        showFieldAApproval && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            onClick: approveACallback,
                                                            disabled: approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING,
                                                            width: "100%",
                                                            children: approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                                                                children: t("Enabling %asset%", {
                                                                    asset: (ref26 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref26 === void 0 ? void 0 : ref26.symbol
                                                                })
                                                            }) : t("Enable %asset%", {
                                                                asset: (ref27 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref27 === void 0 ? void 0 : ref27.symbol
                                                            })
                                                        }),
                                                        showFieldBApproval && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            onClick: approveBCallback,
                                                            disabled: approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING,
                                                            width: "100%",
                                                            children: approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                                                                children: t("Enabling %asset%", {
                                                                    asset: (ref28 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref28 === void 0 ? void 0 : ref28.symbol
                                                                })
                                                            }) : t("Enable %asset%", {
                                                                asset: (ref29 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref29 === void 0 ? void 0 : ref29.symbol
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                                                    isLoading: preferZapInstead && zapInEstimating,
                                                    variant: !isValid || zapIn.priceSeverity > 2 ? "danger" : "primary",
                                                    onClick: function() {
                                                        if (preferZapInstead) {
                                                            setLiquidityState({
                                                                attemptingTxn: false,
                                                                liquidityErrorMessage: undefined,
                                                                txHash: undefined
                                                            });
                                                            onPresentZapInModal();
                                                            return;
                                                        }
                                                        if (expertMode) {
                                                            onAdd();
                                                        } else {
                                                            setLiquidityState({
                                                                attemptingTxn: false,
                                                                liquidityErrorMessage: undefined,
                                                                txHash: undefined
                                                            });
                                                            onPresentAddLiquidityModal();
                                                        }
                                                    },
                                                    disabled: buttonDisabled,
                                                    children: errorText || t("Supply")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            !(addIsUnsupported || addIsWarning) ? pair && !noLiquidity && pairState !== usePairs/* PairState.INVALID */._G.INVALID ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                style: {
                    minWidth: "20rem",
                    width: "100%",
                    maxWidth: "400px",
                    marginTop: "1rem"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionCard/* MinimalPositionCard */.W, {
                    showUnwrapped: oneCurrencyIsWNATIVE,
                    pair: pair
                })
            }) : null : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsupportedCurrencyFooter/* default */.Z, {
                currencies: [
                    currencies.CURRENCY_A,
                    currencies.CURRENCY_B
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/add/[[...currency]].tsx



var AddLiquidityPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddLiquidity, {});
};
AddLiquidityPage.chains = wagmi/* CHAIN_IDS */.vo;
var __N_SSG = true;
/* harmony default export */ var _currency_ = (AddLiquidityPage);


/***/ }),

/***/ 70372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AQ": function() { return /* binding */ stakeFarm; },
/* harmony export */   "dU": function() { return /* binding */ unstakeFarm; },
/* harmony export */   "sA": function() { return /* binding */ harvestFarm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97478);






var options = {
    gasLimit: config__WEBPACK_IMPORTED_MODULE_2__/* .BOOSTED_FARM_GAS_LIMIT */ .ZM
};
var stakeFarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(masterChefContract, pid, amount, gasPrice) {
        var value;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    value = new (bignumber_js__WEBPACK_IMPORTED_MODULE_1___default())(amount).times(config__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_TOKEN_DECIMAL */ .o3).toString();
                    return _ctx.abrupt("return", masterChefContract.deposit(pid, value, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function stakeFarm(masterChefContract, pid, amount, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();
var unstakeFarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(masterChefContract, pid, amount, gasPrice) {
        var value;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    value = new (bignumber_js__WEBPACK_IMPORTED_MODULE_1___default())(amount).times(config__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_TOKEN_DECIMAL */ .o3).toString();
                    return _ctx.abrupt("return", masterChefContract.withdraw(pid, value, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function unstakeFarm(masterChefContract, pid, amount, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();
var harvestFarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(masterChefContract, pid, gasPrice) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", masterChefContract.deposit(pid, "0", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function harvestFarm(masterChefContract, pid, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 56946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zj": function() { return /* reexport */ callWithEstimateGas; },
  "yp": function() { return /* reexport */ getActivePools; },
  "sA": function() { return /* reexport */ farms/* harvestFarm */.sA; },
  "AQ": function() { return /* reexport */ farms/* stakeFarm */.AQ; },
  "dU": function() { return /* reexport */ farms/* unstakeFarm */.dU; }
});

// UNUSED EXPORTS: estimateGas

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
;// CONCATENATED MODULE: ./src/utils/calls/estimateGas.ts





/**
 * Estimate the gas needed to call a function, and add a 10% margin
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param gasMarginPer10000 The gasMargin per 10000 (i.e. 10% -> 1000)
 * @param args An array of arguments to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var estimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _estimateGas, rawGasEstimation, gasEstimation, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, gasMarginPer10000 = _args.length > 4 ? _args[4] : void 0;
                    ;
                    if (contract[methodName]) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("Method ".concat(methodName, " doesn't exist on ").concat(contract.address));
                case 4:
                    _ctx.next = 6;
                    return (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                        overrides
                    ]));
                case 6:
                    rawGasEstimation = _ctx.sent;
                    gasEstimation = (0,utils/* calculateGasMargin */.yC)(rawGasEstimation, gasMarginPer10000);
                    return _ctx.abrupt("return", gasEstimation);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function estimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Perform a contract call with a gas value returned from estimateGas
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param methodArgs An array of arguments to pass to the method
 * @param overrides An overrides object to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var callWithEstimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _contract, gasEstimation, tx, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, gasMarginPer10000 = _args.length > 4 && _args[4] !== void 0 ? _args[4] : 1000;
                    ;
                    _ctx.next = 4;
                    return estimateGas(contract, methodName, methodArgs, overrides, gasMarginPer10000);
                case 4:
                    gasEstimation = _ctx.sent;
                    _ctx.next = 7;
                    return (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                        (0,_object_spread/* default */.Z)({
                            gasLimit: gasEstimation
                        }, overrides)
                    ]));
                case 7:
                    tx = _ctx.sent;
                    return _ctx.abrupt("return", tx);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function callWithEstimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/calls/farms.ts
var farms = __webpack_require__(70372);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(62712);
// EXTERNAL MODULE: ./src/config/abi/sousChefV2.json
var sousChefV2 = __webpack_require__(9022);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./src/utils/providers.ts
var providers = __webpack_require__(62621);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(8414);
;// CONCATENATED MODULE: ./src/utils/calls/pools.ts
/* eslint-disable import/prefer-default-export */ 









/**
 * Returns the total number of pools that were active at a given block
 */ var getActivePools = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(block) {
        var eligiblePools, blockNumber, startBlockCalls, endBlockCalls, ref, startBlocks, endBlocks;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eligiblePools = pools/* default.filter */.ZP.filter(function(pool) {
                        return pool.sousId !== 0;
                    }).filter(function(pool) {
                        return pool.isFinished === false || pool.isFinished === undefined;
                    });
                    _ctx.t0 = block;
                    if (_ctx.t0) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 5;
                    return providers/* bscRpcProvider.getBlockNumber */.v.getBlockNumber();
                case 5:
                    _ctx.t0 = _ctx.sent;
                case 6:
                    blockNumber = _ctx.t0;
                    startBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "startBlock"
                        };
                    });
                    endBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "bonusEndBlock"
                        };
                    });
                    _ctx.t1 = _sliced_to_array/* default */.Z;
                    _ctx.next = 12;
                    return Promise.all([
                        (0,multicall/* default */.Z)(sousChefV2, startBlockCalls),
                        (0,multicall/* default */.Z)(sousChefV2, endBlockCalls), 
                    ]);
                case 12:
                    _ctx.t2 = _ctx.sent;
                    ref = (0, _ctx.t1)(_ctx.t2, 2);
                    startBlocks = ref[0];
                    endBlocks = ref[1];
                    return _ctx.abrupt("return", eligiblePools.reduce(function(accum, poolCheck, index) {
                        var startBlock = startBlocks[index] ? new (bignumber_default())(startBlocks[index]) : null;
                        var endBlock = endBlocks[index] ? new (bignumber_default())(endBlocks[index]) : null;
                        if (!startBlock || !endBlock) {
                            return accum;
                        }
                        if (startBlock.gte(blockNumber) || endBlock.lte(blockNumber)) {
                            return accum;
                        }
                        return (0,_to_consumable_array/* default */.Z)(accum).concat([
                            poolCheck
                        ]);
                    }, []));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getActivePools(block) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/calls/index.ts





/***/ }),

/***/ 54146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getLPSymbol; }
/* harmony export */ });
var getLPSymbol = function(token0Symbol, token1Symbol) {
    if (token0Symbol === "WBNB") {
        return "BNB-".concat(token1Symbol, " LP");
    }
    if (token0Symbol === "WETH") {
        return "ETH-".concat(token1Symbol, " LP");
    }
    if (token1Symbol === "WBNB") {
        return "".concat(token0Symbol, "-BNB LP");
    }
    if (token1Symbol === "WETH") {
        return "".concat(token0Symbol, "-ETH LP");
    }
    return "".concat(token0Symbol, "-").concat(token1Symbol, " LP");
};


/***/ }),

/***/ 11372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ maxAmountSpend; }
/* harmony export */ });
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46472);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56974);


/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */ function maxAmountSpend(currencyAmount) {
    var ref;
    if (!currencyAmount) return undefined;
    if ((ref = currencyAmount.currency) === null || ref === void 0 ? void 0 : ref.isNative) {
        if (_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThan */ .QA.greaterThan(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz)) {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.subtract */ .QA.subtract(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz));
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .BIG_INT_ZERO */ .iV);
    }
    return currencyAmount;
}


/***/ }),

/***/ 81135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ZapErrorMessages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19237);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44147);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27208);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52775);




var ZapErrorMessages = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var isSingleToken = param.isSingleToken, zapMode = param.zapMode, toggleZapMode = param.toggleZapMode, onModalDismiss = param.onModalDismiss;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var toastInfo = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* .useToast */ .p)().toastInfo;
    var handleCloseButton = function() {
        onModalDismiss();
        if (zapMode) {
            toggleZapMode(!zapMode);
            toastInfo(t("Info"), t("Temporarily disabled Zap"));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        margin: "auto",
        width: [
            "100%",
            "100%",
            "380px"
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            variant: "warning",
            mb: "16px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* .MessageText */ .Y, {
                        bold: true,
                        children: t("Currently using Zap for liquidity provisions.")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* .MessageText */ .Y, {
                        small: true,
                        children: [
                            isSingleToken ? t("Zap does NOT support tokens with fees on transfers. If you experience any issues, click") : t("Zap does NOT support tokens with fees on transfers. Please choose ’Don't convert’ and retry. If you experience any further issues, click"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                p: "0 4px",
                                scale: "sm",
                                variant: "text",
                                height: "auto",
                                onClick: handleCloseButton,
                                children: t("here")
                            }),
                            t("to disable Zap temporarily.")
                        ]
                    })
                ]
            })
        })
    });
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6534,4165,5855,3812,5470,6749,1548,6688,3393,9774,2888,179], function() { return __webpack_exec__(32990); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);